import React from "react";
import { useState, useRef, useEffect, useCallback } from "react";

// ─── CONFIGURATION ─────────────────────────────────────────────────────────
const ANTHROPIC_API_KEY = ""; // Key is now handled securely by the Netlify proxy function
const ACCESS_CODE = "kxlab";
const SESSION_ID = "chl2025"; // change per event to isolate leaderboard data
const ADMIN_PASSWORD = "kxwizard-admin-2025"; // change this to something only you know

// ─── UNIVERSITY DATA (Rivendell — fantasy name, real ops data) ─────────────
const UNIVERSITY_DATA = {
  name: "Rivendell University",
  nickname: "The Last Homely House of Higher Ed",
  location: "Rivendell, Middle-earth",
  totalBeds: 2840,
  occupancyRate: 94.2,
  residents: [
    { id:"R001", name:"Jordan Mills",     building:"Maple Hall",  room:"214", classification:"Second Year Student", moveIn:"Aug 18", moveOut:"May 10", email:"j.mills@rivendell.edu",     flag:null },
    { id:"R002", name:"Sofia Reyes",      building:"Maple Hall",  room:"318", classification:"Senior",    moveIn:"Aug 18", moveOut:"Dec 14", email:"s.reyes@rivendell.edu",     flag:"Early checkout Dec 14 — notify housing Jan placement" },
    { id:"R003", name:"Layla Torres",     building:"Maple Hall",  room:"420", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"l.torres@rivendell.edu",    flag:null },
    { id:"R004", name:"Devon Okafor",     building:"Maple Hall",  room:"118", classification:"First Year Student",  moveIn:"Aug 16", moveOut:"May 10", email:"d.okafor@rivendell.edu",    flag:"3 maintenance tickets open — follow up" },
    { id:"R005", name:"Camille Fontaine", building:"Maple Hall",  room:"316", classification:"Second Year Student", moveIn:"Aug 18", moveOut:"May 10", email:"c.fontaine@rivendell.edu",  flag:null },
    { id:"R006", name:"Isaac Brennan",    building:"Maple Hall",  room:"105", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"i.brennan@rivendell.edu",   flag:null },
    { id:"R007", name:"Naomi Osei",       building:"Maple Hall",  room:"222", classification:"First Year Student",  moveIn:"Aug 16", moveOut:"May 10", email:"n.osei@rivendell.edu",      flag:"Accessibility accommodation on file" },
    { id:"R008", name:"Priya Sharma",     building:"Cedar Tower", room:"508", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"p.sharma@rivendell.edu",    flag:null },
    { id:"R009", name:"Tyler Nguyen",     building:"Cedar Tower", room:"207", classification:"First Year Student",  moveIn:"Aug 16", moveOut:"May 10", email:"t.nguyen@rivendell.edu",    flag:null },
    { id:"R010", name:"Brittany Cole",    building:"Cedar Tower", room:"412", classification:"Senior",    moveIn:"Aug 18", moveOut:"May 10", email:"b.cole@rivendell.edu",      flag:"RA — building leadership contact" },
    { id:"R011", name:"Marcus Delgado",   building:"Cedar Tower", room:"309", classification:"Second Year Student", moveIn:"Aug 18", moveOut:"May 10", email:"m.delgado@rivendell.edu",   flag:null },
    { id:"R012", name:"Yuna Park",        building:"Cedar Tower", room:"614", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"y.park@rivendell.edu",      flag:null },
    { id:"R013", name:"Desmond Achebe",   building:"Cedar Tower", room:"101", classification:"Second Year Student", moveIn:"Aug 18", moveOut:"May 10", email:"d.achebe@rivendell.edu",    flag:"Financial hold — confirm enrollment" },
    { id:"R014", name:"Alexis Monroe",    building:"Cedar Tower", room:"215", classification:"First Year Student",  moveIn:"Aug 16", moveOut:"May 10", email:"a.monroe@rivendell.edu",    flag:null },
    { id:"R015", name:"Marcus Webb",      building:"Oak Commons", room:"112", classification:"First Year Student",  moveIn:"Aug 16", moveOut:"May 10", email:"m.webb@rivendell.edu",      flag:"Parent wellness check on file Jun 9" },
    { id:"R016", name:"Aisha Johnson",    building:"Oak Commons", room:"445", classification:"Second Year Student", moveIn:"Aug 18", moveOut:"May 10", email:"a.johnson@rivendell.edu",   flag:null },
    { id:"R017", name:"Zoe Harrington",   building:"Oak Commons", room:"230", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"z.harrington@rivendell.edu",flag:null },
    { id:"R018", name:"Kwame Asante",     building:"Oak Commons", room:"317", classification:"Senior",    moveIn:"Aug 18", moveOut:"May 10", email:"k.asante@rivendell.edu",    flag:"Roommate conflict logged May 22 — monitor" },
    { id:"R019", name:"Tiffany Ruiz",     building:"Oak Commons", room:"408", classification:"First Year Student",  moveIn:"Aug 16", moveOut:"May 10", email:"t.ruiz@rivendell.edu",      flag:null },
    { id:"R020", name:"Ben Holloway",     building:"Oak Commons", room:"119", classification:"Second Year Student", moveIn:"Aug 18", moveOut:"May 10", email:"b.holloway@rivendell.edu",  flag:null },
    { id:"R021", name:"Fatima Al-Rashid", building:"Oak Commons", room:"501", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"f.alrashid@rivendell.edu",  flag:"Halal meal accommodation — dining flagged" },
    { id:"R022", name:"Ethan Park",       building:"Birch Hall",  room:"101", classification:"Graduate",  moveIn:"Aug 18", moveOut:"Jul 31", email:"e.park@rivendell.edu",      flag:null },
    { id:"R023", name:"Dr. Mei Liu",      building:"Birch Hall",  room:"208", classification:"Graduate",  moveIn:"Aug 18", moveOut:"Jul 31", email:"m.liu@rivendell.edu",       flag:"Visiting scholar — international student services notified" },
    { id:"R024", name:"Samuel Adeyemi",   building:"Birch Hall",  room:"312", classification:"Graduate",  moveIn:"Aug 18", moveOut:"May 10", email:"s.adeyemi@rivendell.edu",   flag:null },
    { id:"R025", name:"Clara Okonkwo",    building:"Birch Hall",  room:"415", classification:"Senior",    moveIn:"Aug 18", moveOut:"May 10", email:"c.okonkwo@rivendell.edu",   flag:null },
    { id:"R026", name:"James Thornton",   building:"Birch Hall",  room:"207", classification:"Graduate",  moveIn:"Aug 18", moveOut:"Jul 31", email:"j.thornton@rivendell.edu",  flag:"Repeated noise complaints — 2 documented" },
    { id:"R027", name:"Aaliyah Baptiste", building:"Birch Hall",  room:"320", classification:"Junior",    moveIn:"Aug 18", moveOut:"May 10", email:"a.baptiste@rivendell.edu",  flag:null },
    { id:"R028", name:"Ryan Kowalski",    building:"Birch Hall",  room:"114", classification:"Graduate",  moveIn:"Aug 18", moveOut:"Jul 31", email:"r.kowalski@rivendell.edu",  flag:null },
  ],
  maintenanceTickets: [
    // PATTERN A: Maple Hall hot water infrastructure failure
    { id:"T-2231", building:"Maple Hall",  room:"105", issue:"No hot water — cold shower only, 6am–9am window",                                      priority:"High",   date:"May 28", status:"Closed",      category:"Plumbing",   daysOpen:0  },
    { id:"T-2238", building:"Maple Hall",  room:"214", issue:"Hot water intermittent, takes 12+ min to arrive at tap",                                priority:"Medium", date:"Jun 1",  status:"Open",        category:"Plumbing",   daysOpen:11 },
    { id:"T-2241", building:"Maple Hall",  room:"118", issue:"No hot water — 3rd complaint this semester, resident frustrated",                       priority:"High",   date:"Jun 3",  status:"Open",        category:"Plumbing",   daysOpen:9  },
    { id:"T-2247", building:"Maple Hall",  room:"316", issue:"Hot water cuts out after 5 min — roommates can't both shower before 9am",               priority:"High",   date:"Jun 6",  status:"Open",        category:"Plumbing",   daysOpen:6  },
    { id:"T-2251", building:"Maple Hall",  room:"420", issue:"Water pressure low floors 3–4, hot water barely warm",                                  priority:"High",   date:"Jun 7",  status:"Open",        category:"Plumbing",   daysOpen:5  },
    { id:"T-2255", building:"Maple Hall",  room:"222", issue:"Resident with mobility accommodation cannot shower safely — cold water only",            priority:"Urgent", date:"Jun 9",  status:"In Progress", category:"Plumbing",   daysOpen:3  },
    { id:"T-2258", building:"Maple Hall",  room:"318", issue:"Kitchen sink cold only — shower fine",                                                  priority:"Medium", date:"Jun 10", status:"Open",        category:"Plumbing",   daysOpen:2  },
    // PATTERN B: Cedar Tower HVAC crisis
    { id:"T-2239", building:"Cedar Tower", room:"207", issue:"AC not turning on — room temp 82°F overnight",                                          priority:"High",   date:"Jun 2",  status:"Open",        category:"HVAC",       daysOpen:10 },
    { id:"T-2242", building:"Cedar Tower", room:"508", issue:"AC grinding/rattling noise, stops cooling around midnight",                             priority:"High",   date:"Jun 5",  status:"In Progress", category:"HVAC",       daysOpen:7  },
    { id:"T-2246", building:"Cedar Tower", room:"412", issue:"AC runs constantly but won't drop below 78°F — thermostat unresponsive",                priority:"High",   date:"Jun 6",  status:"Open",        category:"HVAC",       daysOpen:6  },
    { id:"T-2249", building:"Cedar Tower", room:"309", issue:"Shared duct issue suspected — both rooms 307 and 309 warm",                             priority:"Medium", date:"Jun 7",  status:"Open",        category:"HVAC",       daysOpen:5  },
    { id:"T-2252", building:"Cedar Tower", room:"614", issue:"Top floor — AC undersized for unit, recurring issue since last summer",                 priority:"High",   date:"Jun 8",  status:"Open",        category:"HVAC",       daysOpen:4  },
    { id:"T-2256", building:"Cedar Tower", room:"101", issue:"AC musty smell — possible mold in ductwork",                                           priority:"High",   date:"Jun 9",  status:"Open",        category:"HVAC",       daysOpen:3  },
    { id:"T-2260", building:"Cedar Tower", room:"215", issue:"Thermostat replaced last week — still not cooling, may be compressor",                  priority:"Urgent", date:"Jun 11", status:"Open",        category:"HVAC",       daysOpen:1  },
    // PATTERN C: Oak Commons drain/pest cluster
    { id:"T-2243", building:"Oak Commons", room:"112", issue:"Shower drain backing up — floor pooling during use",                                    priority:"Medium", date:"Jun 4",  status:"Open",        category:"Plumbing",   daysOpen:8  },
    { id:"T-2248", building:"Oak Commons", room:"119", issue:"Kitchen drain slow, fruit flies appearing near sink last 3 days",                       priority:"Medium", date:"Jun 7",  status:"Open",        category:"Pest/Drain", daysOpen:5  },
    { id:"T-2253", building:"Oak Commons", room:"230", issue:"Bathroom drain completely clogged — water not draining at all",                         priority:"High",   date:"Jun 8",  status:"Open",        category:"Plumbing",   daysOpen:4  },
    { id:"T-2257", building:"Oak Commons", room:"317", issue:"Fruit flies in kitchen, resident thinks coming from drain or adjacent room",            priority:"Medium", date:"Jun 10", status:"Open",        category:"Pest/Drain", daysOpen:2  },
    { id:"T-2261", building:"Oak Commons", room:"408", issue:"Basement laundry drain backing up — possible blockage further down line",               priority:"High",   date:"Jun 11", status:"Open",        category:"Plumbing",   daysOpen:1  },
    // Birch Hall scattered noise tickets
    { id:"T-2244", building:"Birch Hall",  room:"208", issue:"Window blind broken — slat cracked, won't close fully",                                 priority:"Low",    date:"Jun 5",  status:"Open",        category:"Fixtures",   daysOpen:7  },
    { id:"T-2250", building:"Birch Hall",  room:"312", issue:"Fridge loud hum overnight — food slightly warmer than usual",                           priority:"Medium", date:"Jun 7",  status:"Open",        category:"Appliances", daysOpen:5  },
    { id:"T-2254", building:"Birch Hall",  room:"415", issue:"Door lock stiff — key doesn't turn smoothly",                                          priority:"Medium", date:"Jun 8",  status:"Open",        category:"Security",   daysOpen:4  },
    { id:"T-2259", building:"Birch Hall",  room:"114", issue:"Hallway light flickering 2 weeks — reported twice already",                            priority:"Low",    date:"Jun 10", status:"Open",        category:"Electrical", daysOpen:2  },
  ],
  surveyFeedback: [
    { id:"S01", building:"Maple Hall",  comment:"Staff are so kind but the hot water situation is out of control. My roommate and I can't both shower before 8am anymore.", sentiment:"mixed" },
    { id:"S02", building:"Maple Hall",  comment:"I've submitted 3 tickets about hot water and nothing has changed. Six weeks. I feel like my concerns aren't being taken seriously.", sentiment:"negative" },
    { id:"S03", building:"Maple Hall",  comment:"Honestly Maple is fine? I've never had a hot water problem. Maybe it depends on the floor. My experience has been great.", sentiment:"positive" },
    { id:"S04", building:"Maple Hall",  comment:"The building has character. I love living here. RA programs are great. Hot water thing is annoying but not a dealbreaker.", sentiment:"mostly positive" },
    { id:"S05", building:"Maple Hall",  comment:"Morning showers are a lottery. By 7:30am the hot water is just gone. Floor 3 has complained multiple times. We need infrastructure investment.", sentiment:"negative" },
    { id:"S06", building:"Maple Hall",  comment:"I have an accessibility accommodation and rely on warm water for my morning routine. This has become a real health issue for me.", sentiment:"negative" },
    { id:"S07", building:"Maple Hall",  comment:"The community on my floor is unmatched. We do dinner together twice a week. Housing issues aside, I'd choose Maple again.", sentiment:"positive" },
    { id:"S08", building:"Cedar Tower", comment:"The AC situation has been unbearable. I have a fan running 24/7 and it's still 80 degrees. I've barely slept in two weeks.", sentiment:"negative" },
    { id:"S09", building:"Cedar Tower", comment:"My roommate and I submitted an AC ticket over a week ago. Still waiting. We bought a portable fan but it's not the same.", sentiment:"negative" },
    { id:"S10", building:"Cedar Tower", comment:"The front desk staff at Cedar are the best in the system. They remember my name. The AC problems are real but the staff make it bearable.", sentiment:"mixed" },
    { id:"S11", building:"Cedar Tower", comment:"I'm on the top floor and it's absolutely the worst for heat. The AC units weren't built for summer temperatures here. Not a one-time thing.", sentiment:"negative" },
    { id:"S12", building:"Cedar Tower", comment:"My AC works fine and I don't understand why everyone complains. Maybe they're setting the thermostat wrong? No issues in room 215.", sentiment:"positive" },
    { id:"S13", building:"Cedar Tower", comment:"There's a musty smell from my AC vent. I hope it's not mold. I submitted a ticket but haven't heard back.", sentiment:"negative" },
    { id:"S14", building:"Cedar Tower", comment:"Love the location — close to science buildings. I just wish summer was more manageable temperature-wise. Otherwise happy here.", sentiment:"mixed" },
    { id:"S15", building:"Oak Commons", comment:"The study rooms on floor 2 are incredible. Best in any dorm I've used. Wish they stayed open past 10pm though.", sentiment:"mostly positive" },
    { id:"S16", building:"Oak Commons", comment:"There are fruit flies in my kitchen. Not sure if it's a drain issue or my neighbor but it's been almost a week and it's disgusting.", sentiment:"negative" },
    { id:"S17", building:"Oak Commons", comment:"Programming at Oak Commons has been excellent. Trivia night was a huge hit. The RAs put in real effort. More events like that!", sentiment:"positive" },
    { id:"S18", building:"Oak Commons", comment:"My drain is completely backed up and I've been told maintenance is 'coming soon' for four days. I'm showering at the rec center.", sentiment:"negative" },
    { id:"S19", building:"Oak Commons", comment:"I genuinely love living here. Great community, great location, good staff. Maybe louder quiet hours enforcement on weekends?", sentiment:"positive" },
    { id:"S20", building:"Oak Commons", comment:"The basement laundry is always a disaster. Machines break down, drains back up, smells bad. I've started using the laundromat off campus.", sentiment:"negative" },
    { id:"S21", building:"Oak Commons", comment:"I like the open layouts and common spaces. My only real issue is noise on weekends — walls are thin and some residents aren't respectful.", sentiment:"mixed" },
    { id:"S22", building:"Oak Commons", comment:"Halal meal options through housing have been great this year. They actually listened to last year's feedback. That meant a lot.", sentiment:"positive" },
    { id:"S23", building:"Birch Hall",  comment:"Birch is perfect for graduate students. Quiet, professional atmosphere. Quiet hours consistently enforced and I can work from my room.", sentiment:"positive" },
    { id:"S24", building:"Birch Hall",  comment:"There's one person playing music loudly after 11pm and it's been reported twice. I hope housing takes more decisive action.", sentiment:"negative" },
    { id:"S25", building:"Birch Hall",  comment:"The grad student networking events have been a highlight of my year. Met people across disciplines I'd never have crossed paths with otherwise.", sentiment:"positive" },
    { id:"S26", building:"Birch Hall",  comment:"I'm a visiting international scholar and the housing team was incredibly supportive during onboarding. I felt welcomed from day one.", sentiment:"positive" },
    { id:"S27", building:"Birch Hall",  comment:"My fridge has been making noise for over a week and the ticket doesn't seem to be moving. I don't want to lose food.", sentiment:"negative" },
    { id:"S28", building:"Birch Hall",  comment:"I expected more community here. It's very isolated — people stick to themselves. Sometimes feels like an apartment building, not a residence hall.", sentiment:"negative" },
  ],
  incidentReports: [
    { id:"IR-441", date:"Jun 4",  building:"Maple Hall",  floor:"3", rawNote:"Noise complaint 11:45pm floor 3 room 312 music too loud neighbor knocked on door no answer RA responded knocked resident opened door asked to lower volume complied no further issues documented" },
    { id:"IR-442", date:"Jun 7",  building:"Cedar Tower", floor:"5", rawNote:"Resident locked out room 508 approx 2am called front desk on call RA responded with master key entry successful no damage no third party involved resident fine" },
    { id:"IR-443", date:"Jun 9",  building:"Oak Commons", floor:"1", rawNote:"Wellness check called in by parent for student room 112 stated hadn't heard from student in 36hrs RA conducted check knocked no answer used emergency access student was asleep phone on silent no distress parent called back and informed student also notified of check" },
    { id:"IR-444", date:"Jun 5",  building:"Birch Hall",  floor:"2", rawNote:"Roommate dispute rooms 207 and 208 argument started over noise escalated to verbal altercation in hallway approx 9pm both parties calmed RA mediated no physical contact no property damage both agreed to quiet hours reminder sent to floor" },
    { id:"IR-445", date:"Jun 10", building:"Oak Commons", floor:"4", rawNote:"Smell of marijuana reported room 408 area RA responded conducted hallway check odor present but dissipated by arrival no visible substances no admission resident cooperative standard documentation completed per policy" },
    { id:"IR-446", date:"Jun 11", building:"Maple Hall",  floor:"2", rawNote:"Fire alarm pulled 2:14am building evacuated 218 residents accounted for outside fire dept responded confirmed no fire believed accidental activation near floor 2 kitchen area residents allowed back in by 2:52am no injuries no damage" },
  ],
  occupancy: {
    "Maple Hall":   { total:480, occupied:461, vacant:19 },
    "Cedar Tower":  { total:620, occupied:598, vacant:22 },
    "Oak Commons":  { total:840, occupied:806, vacant:34 },
    "Birch Hall":   { total:900, occupied:808, vacant:92 },
  },

  // ── RA ROSTER — for Quest 3 (Duty Schedule) ──────────────────────────────
  // 4-week window: Aug 25 – Sep 21 | Shifts: weeknights (Mon–Thu) + weekends (Fri/Sat/Sun)
  // Each weekend counts as 1 "weekend block" | Policy: max 1 weekend/month, no back-to-back weekends
  raStaff: [
    { id:"RA01", name:"Jordan Mills",    building:"Maple Hall",  year:"Junior",   constraints:"Unavailable Aug 30–Sep 1 (family commitment). Prefers early weeknight shifts.", maxWeekends:1 },
    { id:"RA02", name:"Priya Sharma",    building:"Cedar Tower", year:"Senior",   constraints:"Class Tuesdays/Thursdays 6–9pm — cannot do weeknight duty those nights. Available all weekends.", maxWeekends:1 },
    { id:"RA03", name:"Marcus Webb",     building:"Oak Commons", year:"Second Year",constraints:"First-time RA — director requests no solo weekend duty first two weeks. Pair with senior RA.", maxWeekends:1 },
    { id:"RA04", name:"Aisha Johnson",   building:"Oak Commons", year:"Junior",   constraints:"Ramadan ends Sep 5 — requests no duties Sep 4–5. Otherwise fully available.", maxWeekends:1 },
    { id:"RA05", name:"Brittany Cole",   building:"Cedar Tower", year:"Senior",   constraints:"RA of the Year nominee — minimal constraints. Willing to take Labor Day weekend (Sep 1).", maxWeekends:1 },
    { id:"RA06", name:"Ethan Park",      building:"Birch Hall",  year:"Graduate", constraints:"Graduate RA — available weeknights only. No weekend duty per grad RA policy.", maxWeekends:0 },
    { id:"RA07", name:"Layla Torres",    building:"Maple Hall",  year:"Junior",   constraints:"Unavailable Sep 14–16 (campus leadership retreat). No other constraints.", maxWeekends:1 },
    { id:"RA08", name:"Kwame Asante",    building:"Oak Commons", year:"Senior",   constraints:"Requested Sep 7–8 weekend off (brother visiting). Available all other weekends.", maxWeekends:1 },
    { id:"RA09", name:"Yuna Park",       building:"Cedar Tower", year:"Junior",   constraints:"No constraints listed. Highly reliable — great for holiday coverage.", maxWeekends:1 },
    { id:"RA10", name:"Aaliyah Baptiste",building:"Birch Hall",  year:"Second Year",constraints:"First-time RA — same as Marcus, no solo weekends first two weeks. Strong communicator.", maxWeekends:1 },
  ],
  dutyPolicy: {
    shiftTypes: ["Weeknight (Mon–Thu, 8pm–8am)", "Weekend (Fri–Sun, 8pm–8am, counts as 1 block)"],
    rules: [
      "Every RA must complete at least 2 weeknight shifts per month",
      "Max 1 weekend block per RA per month (graduate RAs exempt from weekends)",
      "No RA works back-to-back weekend blocks",
      "First-time RAs (Marcus Webb, Aaliyah Baptiste) must be paired with a Senior RA for their first two weekends",
      "Labor Day weekend (Aug 30 – Sep 1) requires 2 RAs on duty each night",
      "Schedule must be published 2 weeks in advance",
      "Swaps allowed with 48hr notice and supervisor approval"
    ],
    blackoutDates: ["Aug 30–Sep 1 (Labor Day — double coverage required)", "Sep 14–16 (Leadership Retreat — 3 RAs unavailable)"]
  },

  // ── EMAIL TEMPLATES & FAQ — for Quest 4 (AI Knowledge Base) ─────────────
  emailTemplates: [
    {
      id:"ET-01", category:"Lockouts", subject:"Lockout Assistance — After Hours",
      body:"Hi [Student Name], thank you for reaching out. After-hours lockout assistance is available by calling the RA on duty at (614) 555-0190. There is a $25 lockout fee for the third and subsequent lockouts in a semester, charged directly to your student account. Please remember to carry your key card at all times. If you have lost your key card permanently, please visit the Housing Office during business hours (Mon–Fri 8am–5pm) to request a replacement ($15 fee). Let us know if you have any other questions!"
    },
    {
      id:"ET-02", category:"Maintenance", subject:"Your Maintenance Request Has Been Received",
      body:"Hi [Student Name], we've received your maintenance request (Ticket #[TICKET_NUMBER]) submitted on [DATE]. Our team will address this within 3–5 business days depending on priority. Urgent issues (no heat, flooding, electrical hazards) are addressed within 24 hours. You do not need to be present for most repairs — our team will enter your room with advance notice per your housing agreement. If your issue becomes more urgent or is not resolved within the timeframe above, please reply to this email or call us at (614) 555-0100."
    },
    {
      id:"ET-03", category:"Roommate Conflict", subject:"Roommate Concern — Next Steps",
      body:"Hi [Student Name], thank you for reaching out about your roommate situation. We take all roommate concerns seriously. Your first step is to meet with your Resident Advisor (RA), who is trained in conflict mediation and can facilitate a roommate agreement conversation. If that does not resolve the issue, you may request a formal mediation meeting with your Hall Director. Room changes are considered only after mediation has been attempted and documented. Please note that room availability is limited, and changes are not guaranteed. Your RA will reach out to schedule a time within 48 hours of receiving this email."
    },
    {
      id:"ET-04", category:"Payment / Financial", subject:"Outstanding Housing Balance — Action Required",
      body:"Hi [Student Name], our records indicate an outstanding balance on your housing account of $[AMOUNT] due by [DUE_DATE]. Please log into your student portal at portal.rivendell.edu to review your balance and make a payment. If you are experiencing financial hardship, the Office of Financial Aid offers emergency housing assistance — please contact them at financialaid@rivendell.edu. Failure to pay by the due date may result in a late fee of $75 and, after 30 days, a hold on your student account preventing registration. Please don't hesitate to reach out if you have questions."
    },
    {
      id:"ET-05", category:"Move-Out", subject:"Move-Out Instructions & Checkout Checklist",
      body:"Hi [Student Name], as your move-out date approaches, here is what you need to know. Checkout appointments are required — schedule yours at housing.rivendell.edu/checkout. Remove all personal belongings by your assigned checkout time. Clean your room (sweep, wipe surfaces, remove trash). Return your key card to the Housing Office or your RA at checkout. Any items left behind will be donated or discarded after 48 hours. Damages beyond normal wear and tear will be charged to your student account within 30 days. Your room condition report from move-in is on file and will be used for comparison. Questions? Email housing@rivendell.edu."
    },
    {
      id:"ET-06", category:"Guest Policy", subject:"Guest & Overnight Visitor Policy",
      body:"Hi [Student Name], thank you for your question about our guest policy. Guests are welcome in your residence hall under the following guidelines: guests must be registered at the front desk upon arrival; overnight guests are permitted for a maximum of 3 consecutive nights and no more than 6 nights per month; your roommate must consent to overnight guests; guests must be accompanied by their host at all times in residential areas; and guests under 17 must have written parental permission on file with the Housing Office. Violation of guest policies may result in loss of guest privileges. Full policy details are available at housing.rivendell.edu/policies."
    },
  ],
  faq: [
    { q:"What are housing office hours?", a:"Mon–Fri 8am–5pm. After-hours emergencies: call RA on duty at (614) 555-0190." },
    { q:"How do I submit a maintenance request?", a:"Log into the resident portal at portal.rivendell.edu and select 'Submit Work Order'. For emergencies (flooding, no heat, electrical), call (614) 555-0100 immediately." },
    { q:"Can I change rooms?", a:"Room changes open after the first 2 weeks of the semester. Submit a Room Change Request form at the Housing Office. Changes depend on availability and require Hall Director approval." },
    { q:"What is the quiet hours policy?", a:"Sun–Thu: 10pm–8am. Fri–Sat: midnight–10am. Courtesy hours (reasonable noise levels) apply 24/7." },
    { q:"How do I add a meal plan?", a:"Contact the Dining Services office at dining@rivendell.edu or visit the Housing Office. Changes can be made through the 3rd week of the semester." },
    { q:"What happens if I lose my key card?", a:"Report it immediately to the Housing Office. Temporary access available at the front desk. Replacement cost is $15. If you believe it was stolen, also file a report with Campus Security." },
    { q:"Can I have a pet?", a:"Only approved service animals and emotional support animals (with documented ESA letter on file) are permitted. Fish in tanks up to 10 gallons are allowed in all halls." },
    { q:"What do I do during a fire alarm?", a:"Evacuate immediately using stairs (never elevators). Bring your key card. Go to your building's designated assembly point. Do not re-enter until cleared by staff or fire department." },
  ],

  // ── TREND DATA — for Quest 5 (Strategic Insight) ─────────────────────────
  trendData: {
    occupancyHistory: [
      { year:"2022–23", "Maple Hall":91.2, "Cedar Tower":88.4, "Oak Commons":96.1, "Birch Hall":72.3 },
      { year:"2023–24", "Maple Hall":93.8, "Cedar Tower":91.2, "Oak Commons":97.4, "Birch Hall":79.6 },
      { year:"2024–25", "Maple Hall":95.8, "Cedar Tower":94.1, "Oak Commons":98.2, "Birch Hall":84.1 },
      { year:"2025–26", "Maple Hall":96.0, "Cedar Tower":96.5, "Oak Commons":96.0, "Birch Hall":89.8 },
    ],
    academicDistribution: [
      { building:"Maple Hall",   avgGPA:2.81, topMajors:["Undeclared","Communications","Business"],       retentionRate:"68%", notes:"Highest concentration of academic probation cases (11% of residents). Most noise complaints campus-wide." },
      { building:"Cedar Tower",  avgGPA:3.12, topMajors:["Engineering","Computer Science","Biology"],     retentionRate:"84%", notes:"AC infrastructure issues correlating with 3 residents requesting building transfers this semester." },
      { building:"Oak Commons",  avgGPA:3.28, topMajors:["Nursing","Education","Psychology"],             retentionRate:"89%", notes:"Highest resident satisfaction historically. Drain cluster issues emerged this semester — first maintenance spike in 3 years." },
      { building:"Birch Hall",   avgGPA:3.71, topMajors:["Graduate Research","Law","MBA"],                retentionRate:"94%", notes:"Consistently highest GPA and retention. Vacancy historically linked to limited social programming for grad students." },
    ],
    maintenanceHistory: [
      { building:"Maple Hall",  tickets2324:12, tickets2425:18, tickets2526:21, primaryCategory:"Plumbing", note:"Hot water complaints increased 75% YoY. Infrastructure age: 34 years." },
      { building:"Cedar Tower", tickets2324:8,  tickets2425:11, tickets2526:19, primaryCategory:"HVAC",     note:"AC unit failures increasing each summer. Units installed 2009 — approaching end of service life." },
      { building:"Oak Commons", tickets2324:6,  tickets2425:7,  tickets2526:14, primaryCategory:"Plumbing", note:"Drain cluster is anomalous — likely linked to tree root intrusion in main sewer line (campus facilities investigating)." },
      { building:"Birch Hall",  tickets2324:9,  tickets2425:8,  tickets2526:6,  primaryCategory:"Misc",     note:"Ticket volume declining — recent renovation (2023) appears to be working." },
    ],
  }
};

// ─── EXERCISES ─────────────────────────────────────────────────────────────
const EXERCISES = [
  {
    id:1, emoji:"✉️", title:"Draft Resident Communication",
    objective:"Use AI to write a targeted email to residents about upcoming move-in day.",
    context:"Move-in is approaching. First Year Students arrive Aug 16, returning students Aug 18. Oak Commons and Cedar Tower first year students need arrival instructions — what to bring, where to check in, what to expect.",
    instruction:"Write a move-in email to a specific group of residents. Tell the AI who you're writing to, which building, the date, and what tone you want.",
    starterText:"",
    teachingFocus:["Audience & context","Tone control","Personalization"],
    crestFocus:"Context + Task — specify WHO and WHAT clearly",
    promptingTip:"Think about who's reading this and what they actually need to know.",
    timeEstimate:"8 min"
  },
  {
    id:2, emoji:"🔧", title:"Summarize Operations Data",
    objective:"Ask AI to find patterns across maintenance tickets and tell you what to prioritize.",
    context:"23 open tickets across 4 buildings. Your maintenance team is stretched thin. You need to know what's truly systemic vs. a one-off before your team meeting Monday.",
    instruction:"Ask the AI to review the tickets and surface the most important patterns. Try asking it to rank buildings, identify recurring issues, or suggest what to tell your team.",
    starterText:"",
    teachingFocus:["Pattern recognition","Prioritization","Ops summarization"],
    crestFocus:"Role + Structure — tell the AI you're a housing director who needs a structured briefing",
    promptingTip:"Think about what format would actually be useful for your team.",
    timeEstimate:"7 min"
  },
  {
    id:3, emoji:"📅", title:"Build the RA Duty Schedule",
    objective:"Use AI to generate a fair, constraint-aware RA duty schedule for the month — a task that normally takes hours of back-and-forth.",
    context:"It's August and you need to publish the September duty schedule for your 10 RAs. You have their availability constraints, blackout dates, first-timer pairing requirements, Labor Day double-coverage needs, and the leadership retreat gap all loaded in the system. This is real data — no spreadsheet needed.",
    instruction:"Ask the AI to build a fair September duty schedule using the RA roster and duty policy already in the system. Tell it what format you want, how to handle conflicts, and what fairness means to you.",
    starterText:"",
    teachingFocus:["Role assignment","Constraint handling","Structured output"],
    crestFocus:"Role + Style — tell the AI you're the Hall Director and specify exactly what the output should look like",
    promptingTip:"Think about what would make a schedule actually usable — and what fairness means to your team.",
    timeEstimate:"7 min"
  },
  {
    id:4, emoji:"🧠", title:"Build Your Department's AI Brain",
    objective:"Turn Rivendell's scattered email templates and FAQ into a searchable, usable knowledge base your entire front desk team could rely on.",
    context:"Your housing office has 6 canned email templates and 8 FAQ answers living in the system — the kind of thing that normally sits in a shared drive nobody can find. Your goal: ask AI to organize this into something your front desk staff, RAs, and phone-answering team could actually use daily without hunting through folders.",
    instruction:"Ask the AI to build a knowledge base, routing guide, or quick-reference system from the email templates and FAQ already in the system. Think about who will use it and what they need to find fast.",
    starterText:"",
    teachingFocus:["Knowledge organization","Role-based output","Real workflow impact"],
    crestFocus:"Role + Example + Style — who uses this, what does a good entry look like, what format works for your team",
    promptingTip:"Think about the last time a staff member asked you a question they should have been able to answer themselves.",
    timeEstimate:"8 min"
  },
  {
    id:5, emoji:"🔮", title:"The Strategic Insight Nobody Had Time For",
    objective:"Use everything in Rivendell's data — occupancy trends, maintenance history, GPA distribution, survey feedback — to surface a strategic insight your director has never seen in a report.",
    context:"You have 4 years of occupancy data, 3 years of maintenance ticket trends by building, academic performance distribution, survey sentiment, and this semester's incident patterns — all in the system. No one has ever looked at all of it together. You're about to.",
    instruction:"Ask the AI to analyze across multiple data sets and find something your director should know that your current reporting tools would never surface. Connect the dots between buildings, students, facilities, and satisfaction.",
    starterText:"",
    teachingFocus:["Cross-data analysis","Executive communication","Strategic thinking"],
    crestFocus:"All 5 CREST elements — Context (what data), Role (housing director briefing VP), Example (the kind of insight you want), Style (brief executive summary, 3 findings max), Task (what patterns matter most)",
    promptingTip:"Think about a question your director has asked that you never had the data to answer.",
    timeEstimate:"8 min"
  }
];

// ─── CREST SCORING ─────────────────────────────────────────────────────────
// Silently score every user prompt on 5 dimensions, 0–2 each (max 10)
function buildScoringPrompt(userPrompt, exerciseId, conversationHistory) {
  // Build full conversation context if multi-turn
  const allUserMessages = conversationHistory
    ? conversationHistory.filter(m => m.role === "user").map(m => m.content).join("\n---\n")
    : userPrompt;

  return `You are a prompt quality evaluator for a student housing AI training session. Score the user's COMPLETE prompting effort using the CREST framework. Be generous with partial credit.

IMPORTANT RULES:
- Score the ENTIRE conversation from the user, not just the last message. If they built up context across multiple messages, that counts.
- If the user referenced a real university URL or external resource to provide context, treat that as strong Context (C) — it shows they understand how to ground AI with real data.
- If the user asked clarifying follow-up questions or refined their request across messages, score the combined intent.
- A prompt that clearly asks for something specific about housing should not score below 4 total.
- Only truly one-word or content-free conversations should score 0-2 total.
- Reserve 0 for truly absent elements only — 1 means the element is present in any recognizable form.

SCORING GUIDE (0, 1, or 2 for each):
C - Context: Did the user provide background about the situation, university, data, or real institutional resources? (0=none at all, 1=some context implied or partial, 2=clear specific context including real details, URLs, or institutional specifics)
R - Role: Did the user give the AI a role or mention who they are? (0=no role, 1=role implied by task, 2=explicit role stated)
E - Examples: Did the user describe desired output, format, or reference examples? (0=no hint, 1=output type implied, 2=explicit example or format described)
S - Structure: Did the user specify format, sections, tone, length, or style? (0=none, 1=some implied, 2=explicitly requested)
T - Task: Is there a clear ask across the conversation? (0=completely unclear, 1=vague but present, 2=specific and actionable)

Exercise ${exerciseId} — Full user conversation:
"""
${allUserMessages}
"""

Respond ONLY with valid JSON, no other text:
{"C":0,"R":0,"E":0,"S":0,"T":0,"feedback":"one specific, encouraging sentence about how to make this prompting even stronger"}`;
}

// ─── SYSTEM PROMPT — exercise-aware ──────────────────────────────────────
function buildSystemPrompt(exerciseId) {
  const exId = exerciseId || 1;

  const core = `You are KxWizard, the AI assistant for Rivendell University Housing & Residence Life. Location: Rivendell, Middle-earth. Beds: 2,840. Occupancy: 94.2%. Always cite real names, IDs, building names from the data. Never be generic. SCOPE: Student housing questions only — redirect off-topic questions with wizard wit. FORMAT: Use headers/bullets for multi-part responses. Be specific and actionable. TONE: Warm, collegial, slightly wizard-playful.`;

  // Occupancy snapshot — always included, small
  const occSnap = Object.entries(UNIVERSITY_DATA.occupancy)
    .map(([b,o])=>`${b}: ${o.occupied}/${o.total} (${Math.round(o.occupied/o.total*100)}%)`)
    .join(" | ");

  // Exercise 1: residents (key fields only) + incidents (summary only)
  if (exId === 1) {
    const residents = UNIVERSITY_DATA.residents
      .map(r=>`${r.name}|${r.building} Rm ${r.room}|${r.classification}|Move-in:${r.moveIn}${r.flag?" ⚑ "+r.flag:""}`)
      .join("\n");
    const incidents = UNIVERSITY_DATA.incidentReports
      .map(i=>`${i.id}|${i.building}|${i.date}|${i.rawNote.slice(0,80)}`)
      .join("\n");
    return `${core}\n\nOCCUPANCY: ${occSnap}\n\nRESIDENTS:\n${residents}\n\nINCIDENT REPORTS:\n${incidents}\n\nBEHAVIOR: Write complete ready-to-send emails. Include subject line, greeting, body, sign-off. Use resident names and building details. Keep responses under 300 words.`;
  }

  // Exercise 2: tickets (key fields) + surveys (first 16, trimmed)
  if (exId === 2) {
    const tickets = UNIVERSITY_DATA.maintenanceTickets
      .map(t=>`${t.id}|${t.building}|${t.category}|${t.issue.slice(0,60)}|${t.priority}|${t.daysOpen}d`)
      .join("\n");
    const surveys = UNIVERSITY_DATA.surveyFeedback.slice(0,16)
      .map(s=>`[${s.building}] ${s.sentiment}: ${s.comment.slice(0,80)}`)
      .join("\n");
    return `${core}\n\nKEY PATTERNS: Maple Hall=plumbing crisis (7 tickets), Cedar Tower=HVAC failure (7 tickets), Oak Commons=drain/pest cluster (5 tickets)\n\nTICKETS:\n${tickets}\n\nSURVEY SAMPLE (16 of 28):\n${surveys}\n\nBEHAVIOR: Find patterns. Cite ticket IDs. Format as briefing. Under 350 words.`;
  }

  // Exercise 3: RA roster + policy (constraints trimmed)
  if (exId === 3) {
    const roster = UNIVERSITY_DATA.raStaff
      .map(r=>`${r.id}|${r.name}|${r.building}|${r.year}|Wknds:${r.maxWeekends}|${r.constraints.slice(0,80)}`)
      .join("\n");
    const rules = UNIVERSITY_DATA.dutyPolicy.rules.slice(0,5).join(" | ");
    const blackouts = UNIVERSITY_DATA.dutyPolicy.blackoutDates.join("; ");
    return `${core}\n\nRA SCHEDULING: Aug 25–Sep 21. Weeknights Mon-Thu + Weekend blocks Fri-Sun.\nBlackouts: ${blackouts}\nRules: ${rules}\n\nRAS:\n${roster}\n\nBEHAVIOR: Show week-by-week schedule as Date|Shift|RA|Building. Respect all constraints. Flag any trade-offs. Under 400 words.`;
  }

  // Exercise 4: templates (subject + first 200 chars of body) + FAQ (trimmed)
  if (exId === 4) {
    const templates = UNIVERSITY_DATA.emailTemplates
      .map(e=>`[${e.id}|${e.category}] "${e.subject}" — ${e.body.slice(0,180)}…`)
      .join("\n");
    const faq = UNIVERSITY_DATA.faq
      .map(f=>`Q: ${f.q} → ${f.a.slice(0,100)}`)
      .join("\n");
    return `${core}\n\nTEMPLATES:\n${templates}\n\nFAQ:\n${faq}\n\nBEHAVIOR: Build a routing guide sorted by situation. For each: trigger phrase, template ID, key detail to verify. Scannable for front desk staff. Under 400 words.`;
  }

  // Exercise 5: numbers only, no prose
  if (exId === 5) {
    const occHistory = UNIVERSITY_DATA.trendData.occupancyHistory
      .map(y=>`${y.year.slice(0,4)}: M${y["Maple Hall"]} C${y["Cedar Tower"]} O${y["Oak Commons"]} B${y["Birch Hall"]}`)
      .join(" | ");
    const acad = UNIVERSITY_DATA.trendData.academicDistribution
      .map(b=>`${b.building.split(" ")[0]}: GPA ${b.avgGPA} Ret ${b.retentionRate} ${b.topMajors[0]}`)
      .join(" | ");
    const maint = UNIVERSITY_DATA.trendData.maintenanceHistory
      .map(b=>`${b.building.split(" ")[0]}: ${b.tickets2324}->${b.tickets2425}->${b.tickets2526} (${b.primaryCategory})`)
      .join(" | ");
    return `${core}\n\nOCCUPANCY: ${occSnap}\nTRENDS: ${occHistory}\nACADEMICS: ${acad}\nMAINTENANCE: ${maint}\n\nBEHAVIOR: Give 3 strategic insights. 2 sentences each. Cite numbers. Under 300 words. Start with Insight 1.`;
  }

  // Fallback
  return `${core}\n\nOCCUPANCY: ${occSnap}`;
}
// ─── STORAGE HELPERS ───────────────────────────────────────────────────────
async function saveResponse(adventurerName, exerciseId, prompt, response, crestScores) {
  try {
    const record = { adventurerName, exerciseId, prompt, response: response.slice(0,500), crestScores, ts: Date.now(), session: SESSION_ID };
    await fetch("/.netlify/functions/store", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "save", key: `${SESSION_ID}:${adventurerName}:ex${exerciseId}:${Date.now()}`, value: record })
    });
  } catch(e) { console.warn("Storage save failed", e); }
}

async function loadAllResponses() {
  try {
    const r = await fetch("/.netlify/functions/store", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "list", prefix: SESSION_ID })
    });
    const data = await r.json();
    return data.records || [];
  } catch(e) { return []; }
}

// ─── MAIN APP ──────────────────────────────────────────────────────────────
export default function KxWizard() {
  const [accessCode, setAccessCode]         = useState("");
  const [accessError, setAccessError]       = useState(false);
  const [admitted, setAdmitted]             = useState(false);
  const [showAdmin, setShowAdmin]           = useState(() => window.location.search.includes("admin=true"));
  const [adminPassword, setAdminPassword]   = useState("");
  const [adminAuthed, setAdminAuthed]       = useState(false);
  const [adminError, setAdminError]         = useState(false);
  const [adminData, setAdminData]           = useState([]);
  const [adminLoading, setAdminLoading]     = useState(false);
  const [adventurerName, setAdventurerName] = useState("");
  const [nameSubmitted, setNameSubmitted]   = useState(false);
  const [messages, setMessages]             = useState([]);
  const [input, setInput]                   = useState("");
  const [isLoading, setIsLoading]           = useState(false);
  const [currentExercise, setCurrentExercise] = useState(0);
  const [completedExercises, setCompletedExercises] = useState(new Set());
  const [streamingText, setStreamingText]   = useState("");
  const [contextExpanded, setContextExpanded] = useState(true);
  const [lastCrest, setLastCrest]           = useState(null);
  const [exerciseHistory, setExerciseHistory] = useState({}); // {exIdx: {messages, lastCrest}}
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [showCelebration, setShowCelebration] = useState(false);
  const [mobileTab, setMobileTab] = useState("workspace");
  const [accordions, setAccordions] = useState({occ:false, maint:false, survey:false, ra:false, templates:false, trends:false});
  const [adventurerEmail, setAdventurerEmail] = useState("");
  const [bestScores, setBestScores] = useState({});      // {exIdx: {C,R,E,S,T,total,feedback}}
  const [showFinalGrade, setShowFinalGrade] = useState(false);
  const [finalGradeData, setFinalGradeData] = useState(null);
  const [showPlayAgainConfirm, setShowPlayAgainConfirm] = useState(false);
  const messagesEndRef = useRef(null);
  const textareaRef    = useRef(null);
  const abortRef       = useRef(null); // AbortController for in-flight requests

  const exercise = EXERCISES[currentExercise];
  const progressPct = (completedExercises.size / EXERCISES.length) * 100;

  useEffect(() => { messagesEndRef.current?.scrollIntoView({ behavior:"smooth" }); }, [messages, streamingText]);

  // Collapse textarea to 2 lines whenever input is empty
  useEffect(() => {
    if (input === "" && textareaRef.current) {
      textareaRef.current.style.height = "auto"; textareaRef.current.rows = 2;
    }
  }, [input]);

  useEffect(() => {
    if (!nameSubmitted) return;
    // Cancel any in-flight request when switching exercises
    if (abortRef.current) { abortRef.current.abort(); abortRef.current = null; }
    setIsLoading(false);
    setStreamingText("");
    setContextExpanded(true);
    setInput("");
    // Restore saved conversation + score when switching exercises
    setExerciseHistory(prev => {
      const saved = prev[currentExercise];
      if (saved) {
        // Use setTimeout so state updates don't collide
        setTimeout(() => {
          setMessages(saved.messages.map((m,i) => ({...m, id: Date.now()+i})));
          setLastCrest(saved.lastCrest || null);
        }, 0);
        setTimeout(() => {
          if (textareaRef.current) textareaRef.current.style.height = "auto"; textareaRef.current.rows = 2;
        }, 50);
      } else {
        setMessages([]);
        setLastCrest(null);
      }
      return prev;
    });
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        textareaRef.current.style.height = "auto";
      }
    }, 100);
  }, [currentExercise, nameSubmitted]);

  useEffect(() => { if (messages.length === 1) setContextExpanded(false); }, [messages.length]);

  const toggleAcc = (k) => setAccordions(prev=>({...prev,[k]:!prev[k]}));

  const AccHeader = ({label, badge, aKey, children}) => (
    <div style={{marginBottom:"12px"}}>
      <button onClick={()=>toggleAcc(aKey)}
        style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:"none",border:"none",cursor:"pointer",padding:"6px 0",fontFamily:"inherit"}}>
        <div style={{display:"flex",alignItems:"center",gap:"6px"}}>
          <span style={{color:"#8B90B8",fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em"}}>{label}</span>
          {badge}
        </div>
        <span style={{color:C.muted,fontSize:"11px",lineHeight:1}}>{accordions[aKey]?"▲":"▼"}</span>
      </button>
      {accordions[aKey] && <div>{children}</div>}
    </div>
  );

  const computeFinalGrade = () => {
    const maxTotal = EXERCISES.length * 10; // 5 exercises × 10 pts each
    const earned = Object.values(bestScores).reduce((s,sc)=>s+(sc.total||0),0);
    const pct = Math.round((earned / maxTotal) * 100);
    let rank, rankEmoji, rankDesc;
    if (pct >= 90) {
      rank="Grand Wizard of Housing AI"; rankEmoji="🧙‍♂️";
      rankDesc="You've mastered the art of AI prompting. Your staff would follow you into any digital dungeon.";
    } else if (pct >= 75) {
      rank="Knight of the Prompt"; rankEmoji="⚔️";
      rankDesc="Strong, precise, and effective. You're ready to bring AI tools back to your team.";
    } else if (pct >= 60) {
      rank="Apprentice Scribe"; rankEmoji="📜";
      rankDesc="You've got the foundation. Keep practicing — the spells get easier with use.";
    } else {
      rank="Seeker of the Algorithm"; rankEmoji="🌱";
      rankDesc="Every wizard starts somewhere. The fact that you're here means you're already ahead of most.";
    }
    // Per-exercise breakdown
    const breakdown = EXERCISES.map((ex,i)=>{
      const sc = bestScores[i];
      return { title:ex.title, emoji:ex.emoji, score:sc?.total||0, scores:sc||null };
    });
    return { earned, maxTotal, pct, rank, rankEmoji, rankDesc, breakdown };
  };

  const handleTurnIn = async () => {
    const grade = computeFinalGrade();
    setFinalGradeData(grade);
    // Save email to shared storage if provided
    if (adventurerEmail.trim()) {
      try {
        await fetch("/.netlify/functions/store", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "save", key: `${SESSION_ID}:email:${adventurerName}`, value: { name:adventurerName, email:adventurerEmail.trim(), pct:grade.pct, rank:grade.rank, ts:Date.now(), type:"email" } })
        });
      } catch(e) { console.warn("Email save failed", e); }
    }
    // Show celebration first, then grade screen when they click "See My Grade"
    setShowCelebration(true);
  };

  const clearConversation = () => {
    setMessages([]); setStreamingText(""); setLastCrest(null);
    setContextExpanded(true); setInput("");
    if (textareaRef.current) { textareaRef.current.style.height="auto"; textareaRef.current.rows=2; }
    // Clear saved history for this exercise so reset is a true restart
    setExerciseHistory(prev => { const n={...prev}; delete n[currentExercise]; return n; });
    setTimeout(() => { if (textareaRef.current) { textareaRef.current.focus(); } }, 50);
  };

  // Silent CREST scoring call
  const scoreCrest = useCallback(async (userPrompt, exId, conversationHistory) => {
    try {
      const r = await fetch("/.netlify/functions/claude", {
        method:"POST",
        headers:{ "Content-Type":"application/json" },
        body: JSON.stringify({ model:"claude-sonnet-4-6", max_tokens:200,
          messages:[{ role:"user", content: buildScoringPrompt(userPrompt, exId, conversationHistory) }] })
      });
      const d = await r.json();
      const text = d.content?.[0]?.text || "{}";
      const clean = text.replace(/```json|```/g,"").trim();
      return JSON.parse(clean);
    } catch(e) { return null; }
  }, []);

  const sendMessage = useCallback(async (messageText) => {
    const text = messageText || input.trim();
    if (!text || isLoading) return;
    setMessages(prev => [...prev, { role:"user", content:text, id:Date.now() }]);
    setInput("");
    if (textareaRef.current) { textareaRef.current.style.height="auto"; textareaRef.current.rows=2; }
    setIsLoading(true); setStreamingText("");

    // Set up AbortController so exercise-switching can cancel this request
    const controller = new AbortController();
    abortRef.current = controller;

    // 45-second hard timeout safety valve
    const timeout = setTimeout(() => {
      controller.abort();
    }, 45000);

    try {
      // Retry up to 3 times on 502/504 timeouts
      let data = null;
      let lastError = null;
      for (let attempt = 1; attempt <= 3; attempt++) {
        try {
          if (attempt > 1) {
            setStreamingText(`🔄 Attempt ${attempt}/3 — the grimoire is consulting deeper archives…`);
            await new Promise(r => setTimeout(r, 1500));
            setStreamingText("");
          }
          const res = await fetch("/.netlify/functions/claude", {
            method:"POST",
            headers:{ "Content-Type":"application/json" },
            body: JSON.stringify({
              model:"claude-sonnet-4-6", max_tokens:1200,
              system: buildSystemPrompt(exercise.id),
              messages:[ ...messages.map(m=>({role:m.role,content:m.content})), {role:"user",content:text} ]
            }),
            signal: controller.signal
          });
          if (res.status === 502 || res.status === 504) {
            lastError = new Error(`API ${res.status}`);
            continue; // retry
          }
          if (!res.ok) throw new Error(`API ${res.status}`);
          data = await res.json();
          if (data.error) throw new Error(data.error);
          break; // success
        } catch(e) {
          if (e.name === "AbortError") throw e; // don't retry aborts
          lastError = e;
          if (attempt === 3) throw lastError;
        }
      }
      let full = data?.content?.[0]?.text || "";
      setStreamingText(full);
      if (textareaRef.current) textareaRef.current.style.height = "auto"; textareaRef.current.rows = 2;
      const finalMessages = [...messages.map(m=>({role:m.role,content:m.content})), {role:"user",content:text}, {role:"assistant",content:full}];
      setMessages(prev => [...prev, { role:"assistant", content:full, id:Date.now() }]);
      setStreamingText("");

      // Mark complete
      const newCompleted = new Set(completedExercises);
      if (!newCompleted.has(currentExercise)) { newCompleted.add(currentExercise); setCompletedExercises(newCompleted); }
      const isLastExercise = newCompleted.size === EXERCISES.length;

      // CREST score (silent, parallel) — celebrate AFTER score arrives so state is clean
      scoreCrest(text, exercise.id, finalMessages).then(scores => {
        const scored = scores ? {...scores, total:["C","R","E","S","T"].reduce((s,d)=>s+(scores[d]||0),0)} : null;
        if (scored) {
          setLastCrest(scored);
          setExerciseHistory(prev => ({
            ...prev,
            [currentExercise]: { messages: finalMessages, lastCrest: scored }
          }));
          setBestScores(prev => {
            const existing = prev[currentExercise];
            if (!existing || scored.total > existing.total) {
              saveResponse(adventurerName, exercise.id, text, full, scored);
              return {...prev, [currentExercise]: scored};
            }
            return prev;
          });
        }
        // Celebrate only after scoring is done — avoids stuck loading state
        // Celebration now only triggered by Turn In button — not auto
      }).catch(() => {
      });

    } catch(err) {
      if (err.name !== "AbortError") {
        // Only show error if not a deliberate abort (exercise switch)
        setMessages(prev => [...prev, { role:"assistant", content:`⚠️ The wizard's connection wavered: ${err.message}. Try again or reset.`, id:Date.now(), isError:true }]);
      }
      setStreamingText("");
    } finally {
      clearTimeout(timeout);
      abortRef.current = null;
      setIsLoading(false);
    }
  }, [input, isLoading, messages, completedExercises, currentExercise, exercise, adventurerName, scoreCrest]);

  const loadLeaderboard = async () => {
    const records = await loadAllResponses();
    // Aggregate by adventurer + exercise, take best CREST total per attempt
    const agg = {};
    for (const r of records) {
      const k = r.adventurerName;
      if (!agg[k]) agg[k] = { name:k, exercisesCompleted:new Set(), totalCrest:0, prompts:[] };
      const total = r.crestScores ? Object.values(r.crestScores).filter(v=>typeof v==="number").reduce((a,b)=>a+b,0) : 0;
      agg[k].exercisesCompleted.add(r.exerciseId);
      agg[k].totalCrest += total;
      agg[k].prompts.push({ exId:r.exerciseId, prompt:r.prompt, crest:r.crestScores, total });
    }
    const sorted = Object.values(agg).map(a=>({...a, exercisesCompleted:a.exercisesCompleted.size}))
      .sort((a,b) => b.totalCrest - a.totalCrest || b.exercisesCompleted - a.exercisesCompleted);
    setLeaderboardData(sorted);
    setShowLeaderboard(true);
  };

  const loadAdminData = async () => {
    setAdminLoading(true);
    const records = await loadAllResponses();
    // Also try to load emails
    try {
      const emailResp = await fetch("/.netlify/functions/store", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "list", prefix: `${SESSION_ID}:email:` })
      });
      const emailData = await emailResp.json();
      const emails = {};
      for (const record of (emailData.records || [])) {
        if (record.name && record.email) emails[record.name] = record.email;
      }
      // Attach emails to records
      records.forEach(r => { r.email = emails[r.adventurerName] || ""; });
    } catch(e) {}
    setAdminData(records);
    setAdminLoading(false);
  };

  const exportAdminCSV = () => {
    const rows = [["Name","Email","Exercise","Prompt","C","R","E","S","T","Total","Feedback","Timestamp"]];
    for (const r of adminData) {
      const c = r.crestScores || {};
      const total = ["C","R","E","S","T"].reduce((s,d)=>s+(c[d]||0),0);
      const exName = EXERCISES.find(e=>e.id===r.exerciseId)?.title || r.exerciseId;
      rows.push([
        `"${(r.adventurerName||"").replace(/"/g,'""')}"`,
        `"${(r.email||"").replace(/"/g,'""')}"`,
        `"${exName}"`,
        `"${(r.prompt||"").replace(/"/g,'""')}"`,
        c.C||0, c.R||0, c.E||0, c.S||0, c.T||0, total,
        `"${(c.feedback||"").replace(/"/g,'""')}"`,
        r.ts ? new Date(r.ts).toLocaleString() : ""
      ]);
    }
    const csv = rows.map(r=>r.join(",")).join("\n");
    const blob = new Blob([csv], {type:"text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `kxwizard-${SESSION_ID}-responses.csv`;
    a.click();
  };

  const exportEmailCSV = () => {
    // Deduplicate emails
    const seen = new Set();
    const rows = [["Name","Email","Score %","Rank"]];
    for (const r of adminData) {
      const key = r.adventurerName + r.email;
      if (!seen.has(key) && r.email) {
        seen.add(key);
        rows.push([
          `"${(r.adventurerName||"").replace(/"/g,'""')}"`,
          `"${(r.email||"").replace(/"/g,'""')}"`,
          "", ""
        ]);
      }
    }
    const csv = rows.map(r=>r.join(",")).join("\n");
    const blob = new Blob([csv], {type:"text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `kxwizard-${SESSION_ID}-emails.csv`;
    a.click();
  };

  const exportCSV = () => {
    const rows = [["Adventurer","Exercise","Prompt","C","R","E","S","T","Total CREST","Feedback","Timestamp"]];
    for (const r of leaderboardData) {
      for (const p of r.prompts) {
        const c = p.crest || {};
        rows.push([r.name, p.exId, `"${(p.prompt||"").replace(/"/g,'""')}"`,
          c.C||0,c.R||0,c.E||0,c.S||0,c.T||0,p.total,`"${(c.feedback||"").replace(/"/g,'""')}"`,""]);
      }
    }
    const csv = rows.map(r=>r.join(",")).join("\n");
    const blob = new Blob([csv], {type:"text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href=url; a.download=`kxwizard-${SESSION_ID}.csv`; a.click();
  };

  // ── STYLES ────────────────────────────────────────────────────────────────
  const C = { bg:"#0A0F1E", panel:"#0D1220", card:"#111827", border:"#1E2A42",
    purple:"#5E28E5", teal:"#26BFA8", text:"#E8EAFF", muted:"#6B7699", faint:"#2A3550",
    red:"#FF6B6B", amber:"#FFB347", urgent:"#FF4444" };

  const pill = (active) => ({
    padding:"6px 10px", borderRadius:"8px", border:"none", cursor:"pointer",
    fontFamily:"inherit", fontSize:"12px", fontWeight:"800", letterSpacing:"0.03em",
    background: active ? C.purple : C.card,
    color: active ? "#fff" : C.muted,
    border: active ? `1px solid ${C.purple}` : `1px solid ${C.border}`,
    transition:"all 0.15s", whiteSpace:"nowrap"
  });

  // ── SCREENS ───────────────────────────────────────────────────────────────

  // 0. Admin screen — only accessible via ?admin=true in URL
  if (showAdmin) {
    if (!adminAuthed) {
      return (
        <div style={{height:"100dvh",background:"#0A0F1E",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Raleway','Segoe UI',sans-serif",padding:"24px"}}>
          <div style={{background:"#0D1220",borderRadius:"20px",padding:"36px 32px",maxWidth:"400px",width:"100%",border:"1px solid #1E2A42",boxShadow:"0 24px 80px rgba(0,0,0,0.5)"}}>
            <div style={{textAlign:"center",marginBottom:"28px"}}>
              <div style={{fontSize:"48px",marginBottom:"12px"}}>🔐</div>
              <h1 style={{color:"#E8EAFF",fontSize:"20px",fontWeight:"900",margin:"0 0 8px"}}>KxWizard Admin</h1>
              <p style={{color:"#6B7699",fontSize:"13px",margin:0}}>Session: {SESSION_ID}</p>
            </div>
            <input
              type="password"
              value={adminPassword}
              onChange={e=>setAdminPassword(e.target.value)}
              onKeyDown={e=>{
                if(e.key==="Enter"){
                  if(adminPassword===ADMIN_PASSWORD){ setAdminAuthed(true); loadAdminData(); }
                  else { setAdminError(true); setTimeout(()=>setAdminError(false),2000); }
                }
              }}
              placeholder="Enter admin password"
              style={{width:"100%",padding:"14px 16px",borderRadius:"12px",background:"#111827",border:`1px solid ${adminError?"#FF6B6B":"#1E2A42"}`,color:"#E8EAFF",fontSize:"15px",fontFamily:"inherit",outline:"none",boxSizing:"border-box",marginBottom:"12px",textAlign:"center"}}
            />
            {adminError && <p style={{color:"#FF6B6B",fontSize:"12px",textAlign:"center",margin:"0 0 10px"}}>Incorrect password</p>}
            <button
              onClick={()=>{
                if(adminPassword===ADMIN_PASSWORD){ setAdminAuthed(true); loadAdminData(); }
                else { setAdminError(true); setTimeout(()=>setAdminError(false),2000); }
              }}
              style={{width:"100%",padding:"14px",borderRadius:"12px",background:"linear-gradient(135deg,#5E28E5,#4312BC)",border:"none",color:"#fff",fontSize:"15px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit"}}>
              Access Admin Panel →
            </button>
          </div>
        </div>
      );
    }

    // Authenticated admin view
    const uniqueAttendees = [...new Set(adminData.map(r=>r.adventurerName))];
    const emailList = [...new Set(adminData.filter(r=>r.email).map(r=>({name:r.adventurerName,email:r.email})))];

    return (
      <div style={{minHeight:"100dvh",background:"#0A0F1E",fontFamily:"'Raleway','Segoe UI',sans-serif",padding:"24px",color:"#E8EAFF"}}>
        <div style={{maxWidth:"900px",margin:"0 auto"}}>

          {/* Header */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"28px",flexWrap:"wrap",gap:"12px"}}>
            <div>
              <h1 style={{margin:0,fontSize:"24px",fontWeight:"900"}}>🧙 KxWizard Admin</h1>
              <p style={{margin:"4px 0 0",fontSize:"13px",color:"#6B7699"}}>Session: {SESSION_ID} · {uniqueAttendees.length} attendees · {adminData.length} total responses</p>
            </div>
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
              <button onClick={loadAdminData} style={{padding:"9px 16px",borderRadius:"8px",background:"#111827",border:"1px solid #1E2A42",color:"#26BFA8",fontSize:"12px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>
                🔄 Refresh
              </button>
              <button onClick={exportEmailCSV} style={{padding:"9px 16px",borderRadius:"8px",background:"#111827",border:"1px solid #1E2A42",color:"#FFB347",fontSize:"12px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>
                📧 Download Emails CSV
              </button>
              <button onClick={exportAdminCSV} style={{padding:"9px 16px",borderRadius:"8px",background:"linear-gradient(135deg,#5E28E5,#4312BC)",border:"none",color:"#fff",fontSize:"12px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>
                📥 Download All Responses CSV
              </button>
            </div>
          </div>

          {adminLoading ? (
            <div style={{textAlign:"center",padding:"60px",color:"#6B7699"}}>Loading session data…</div>
          ) : adminData.length === 0 ? (
            <div style={{textAlign:"center",padding:"60px",color:"#6B7699"}}>
              <p style={{fontSize:"48px",margin:"0 0 16px"}}>📭</p>
              <p>No responses yet for session <strong>{SESSION_ID}</strong>.</p>
              <p style={{fontSize:"12px",marginTop:"8px"}}>Data appears here after attendees complete prompts.</p>
            </div>
          ) : (
            <>
              {/* Email list */}
              {emailList.length > 0 && (
                <div style={{background:"#0D1220",borderRadius:"14px",border:"1px solid #1E2A42",padding:"18px 20px",marginBottom:"16px"}}>
                  <p style={{margin:"0 0 12px",fontSize:"12px",fontWeight:"700",color:"#FFB347",textTransform:"uppercase",letterSpacing:"0.08em"}}>📧 Email List ({emailList.length} subscribers)</p>
                  <div style={{display:"flex",flexWrap:"wrap",gap:"8px"}}>
                    {emailList.map((e,i)=>(
                      <div key={i} style={{padding:"5px 12px",borderRadius:"20px",background:"#111827",border:"1px solid #1E2A42",fontSize:"12px"}}>
                        <span style={{color:"#E8EAFF",fontWeight:"600"}}>{e.name}</span>
                        <span style={{color:"#6B7699",marginLeft:"6px"}}>{e.email}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Per-attendee breakdown */}
              {uniqueAttendees.map(name => {
                const attendeeRecords = adminData.filter(r=>r.adventurerName===name);
                const email = attendeeRecords.find(r=>r.email)?.email;
                const exIds = [...new Set(attendeeRecords.map(r=>r.exerciseId))];
                const totalScore = attendeeRecords.reduce((s,r)=>{
                  const c = r.crestScores||{};
                  return s + ["C","R","E","S","T"].reduce((ss,d)=>ss+(c[d]||0),0);
                }, 0);
                const maxScore = exIds.length * 10;
                const pct = maxScore > 0 ? Math.round((totalScore/maxScore)*100) : 0;

                return (
                  <div key={name} style={{background:"#0D1220",borderRadius:"14px",border:"1px solid #1E2A42",marginBottom:"12px",overflow:"hidden"}}>
                    {/* Attendee header */}
                    <div style={{padding:"14px 20px",borderBottom:"1px solid #1E2A42",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:"8px"}}>
                      <div>
                        <span style={{fontWeight:"800",fontSize:"15px"}}>{name}</span>
                        {email && <span style={{color:"#6B7699",fontSize:"12px",marginLeft:"10px"}}>{email}</span>}
                      </div>
                      <div style={{display:"flex",gap:"12px",alignItems:"center"}}>
                        <span style={{fontSize:"12px",color:"#6B7699"}}>{exIds.length}/5 quests</span>
                        <span style={{fontSize:"16px",fontWeight:"900",color:pct>=75?"#26BFA8":pct>=50?"#FFB347":"#FF6B6B"}}>{pct}%</span>
                      </div>
                    </div>
                    {/* Per-exercise responses */}
                    {attendeeRecords.map((r,i)=>{
                      const c = r.crestScores||{};
                      const total = ["C","R","E","S","T"].reduce((s,d)=>s+(c[d]||0),0);
                      const exName = EXERCISES.find(e=>e.id===r.exerciseId)?.title || `Quest ${r.exerciseId}`;
                      const exEmoji = EXERCISES.find(e=>e.id===r.exerciseId)?.emoji || "📝";
                      return (
                        <div key={i} style={{padding:"12px 20px",borderBottom:i<attendeeRecords.length-1?"1px solid #1A2235":"none"}}>
                          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"6px",flexWrap:"wrap",gap:"6px"}}>
                            <span style={{fontSize:"12px",fontWeight:"700",color:"#9B7AFF"}}>{exEmoji} {exName}</span>
                            <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
                              {["C","R","E","S","T"].map(d=>(
                                <span key={d} style={{fontSize:"10px",fontWeight:"700",color:c[d]>=2?"#26BFA8":c[d]>=1?"#FFB347":"#6B7699",padding:"2px 5px",borderRadius:"4px",background:c[d]>=2?"rgba(38,191,168,0.1)":c[d]>=1?"rgba(255,179,71,0.1)":"rgba(107,118,153,0.1)"}}>{d}{c[d]||0}</span>
                              ))}
                              <span style={{fontSize:"12px",fontWeight:"900",color:total>=8?"#26BFA8":total>=5?"#FFB347":"#FF6B6B",marginLeft:"4px"}}>{total}/10</span>
                            </div>
                          </div>
                          <p style={{margin:"0 0 4px",fontSize:"12px",color:"#E8EAFF",lineHeight:"1.5",background:"#111827",padding:"8px 10px",borderRadius:"8px",fontStyle:"italic"}}>"{r.prompt}"</p>
                          {c.feedback && <p style={{margin:0,fontSize:"11px",color:"#6B7699",lineHeight:"1.5"}}>💡 {c.feedback}</p>}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    );
  }

  // 1. Access code gate
  if (!admitted) {
    const submit = () => {
      if (accessCode.trim().toLowerCase() === ACCESS_CODE) { if (document.activeElement) document.activeElement.blur(); setTimeout(()=>setAdmitted(true),100); }
      else { setAccessError(true); setTimeout(()=>setAccessError(false),2000); }
    };
    return (
      <div style={{height:"100dvh",background:`linear-gradient(135deg, ${C.bg} 0%, #1A1035 100%)`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Raleway','Segoe UI',sans-serif",padding:"24px"}}>
        <div style={{background:C.panel,borderRadius:"20px",padding:"36px 32px",maxWidth:"400px",width:"100%",border:`1px solid ${C.border}`,boxShadow:"0 24px 80px rgba(94,40,229,0.25)"}}>
          <div style={{textAlign:"center",marginBottom:"28px"}}>
            <div style={{fontSize:"52px",marginBottom:"12px",lineHeight:1}}>🧙</div>
            <h1 style={{color:C.text,fontSize:"22px",fontWeight:"900",margin:"0 0 6px"}}>KxWizard</h1>
            <p style={{color:C.muted,fontSize:"13px",margin:0,lineHeight:"1.6"}}>Rivendell University · Housing AI Quest<br/>Campus Home Live 2025</p>
          </div>
          <label style={{display:"block",color:C.muted,fontSize:"11px",fontWeight:"700",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:"8px"}}>Session Access Code</label>
          <input type="text" value={accessCode} onChange={e=>{setAccessCode(e.target.value);setAccessError(false);}}
            onKeyDown={e=>e.key==="Enter"&&submit()} placeholder="Enter the code from your wizard guide"
            autoComplete="off" autoCapitalize="none"
            style={{width:"100%",padding:"14px 16px",borderRadius:"12px",background:C.bg,border:`1px solid ${accessError?"#FF6B6B":C.border}`,color:C.text,fontSize:"16px",fontFamily:"inherit",outline:"none",boxSizing:"border-box",textAlign:"center",letterSpacing:"0.08em"}}/>
          {accessError && <p style={{color:C.red,fontSize:"12px",marginTop:"6px",textAlign:"center",fontWeight:"700"}}>Not quite, adventurer. Check with your wizard guide.</p>}
          <button onClick={submit} style={{width:"100%",padding:"15px",marginTop:"16px",background:`linear-gradient(135deg, ${C.purple}, #4312BC)`,border:"none",borderRadius:"12px",color:"#fff",fontSize:"15px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit"}}>
            Begin the Quest →
          </button>
          <p style={{color:C.faint,fontSize:"12px",marginTop:"20px",textAlign:"center",lineHeight:"1.6"}}>No account needed · No data stored on your device</p>
        </div>
      </div>
    );
  }

  // 2. Adventurer name screen
  if (!nameSubmitted) {
    const submitName = () => {
    if (adventurerName.trim().length >= 2) {
      if (document.activeElement) document.activeElement.blur();
      // Reset zoom by temporarily setting viewport, then restoring
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
        // Force reflow
        setTimeout(() => {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
        }, 50);
      }
      setTimeout(() => setNameSubmitted(true), 150);
    }
  };
    const canEnter = adventurerName.trim().length >= 2;
    return (
      <div style={{height:"100dvh",background:`linear-gradient(135deg, ${C.bg} 0%, #1A1035 100%)`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Raleway','Segoe UI',sans-serif",padding:"24px"}}>
        <div style={{background:C.panel,borderRadius:"20px",padding:"36px 32px",maxWidth:"420px",width:"100%",border:`1px solid ${C.border}`,boxShadow:"0 24px 80px rgba(94,40,229,0.25)"}}>
          <div style={{textAlign:"center",marginBottom:"24px"}}>
            <div style={{fontSize:"52px",marginBottom:"12px",lineHeight:1}}>⚔️</div>
            <h1 style={{color:C.text,fontSize:"20px",fontWeight:"900",margin:"0 0 8px"}}>Name Your Adventurer</h1>
            <p style={{color:C.muted,fontSize:"13px",margin:0,lineHeight:"1.7"}}>Your name appears on the leaderboard.<br/>Your best prompt may be featured in the whitepaper.</p>
          </div>

          {/* Name */}
          <label style={{display:"block",color:C.muted,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:"6px"}}>Your Name or Quest Alias</label>
          <input type="text" value={adventurerName} onChange={e=>setAdventurerName(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&canEnter&&submitName()}
            placeholder="e.g. Jordan Mills, or The Prompt Sage"
            maxLength={40}
            style={{width:"100%",padding:"13px 16px",borderRadius:"12px",background:C.bg,border:`1px solid ${C.border}`,color:C.text,fontSize:"16px",fontFamily:"inherit",outline:"none",boxSizing:"border-box",marginBottom:"12px"}}/>

          {/* Email */}
          <label style={{display:"block",color:C.muted,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:"6px"}}>
            Email <span style={{color:C.muted,fontWeight:"400",textTransform:"none",letterSpacing:"normal"}}>(optional — to receive the whitepaper when published)</span>
          </label>
          <input type="email" value={adventurerEmail} onChange={e=>setAdventurerEmail(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&canEnter&&submitName()}
            placeholder="you@university.edu"
            style={{width:"100%",padding:"13px 16px",borderRadius:"12px",background:C.bg,border:`1px solid ${C.border}`,color:C.text,fontSize:"16px",fontFamily:"inherit",outline:"none",boxSizing:"border-box",marginBottom:"16px"}}/>

          <button onClick={submitName} disabled={!canEnter}
            style={{width:"100%",padding:"15px",background:canEnter?`linear-gradient(135deg, ${C.purple}, #4312BC)`:"#1E2A42",border:"none",borderRadius:"12px",color:"#fff",fontSize:"16px",fontWeight:"800",cursor:canEnter?"pointer":"not-allowed",fontFamily:"inherit",transition:"background 0.2s"}}>
            Enter Rivendell →
          </button>

          <div style={{marginTop:"16px",padding:"12px 14px",background:C.bg,borderRadius:"10px",border:`1px solid ${C.border}`}}>
            <p style={{color:C.teal,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 4px"}}>📜 The Whitepaper Quest</p>
            <p style={{color:C.muted,fontSize:"11px",margin:0,lineHeight:"1.6"}}>The best prompts from today's session will be published in a real whitepaper shared across the student housing field. Your institution gets credited.</p>
          </div>
        </div>
      </div>
    );
  }

  // 3. Leaderboard overlay
  if (showLeaderboard) {
    return (
      <div style={{height:"100dvh",background:C.bg,fontFamily:"'Raleway','Segoe UI',sans-serif",display:"flex",flexDirection:"column",overflow:"hidden"}}>
        <div style={{padding:"16px 20px",background:C.panel,borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
            <span style={{fontSize:"22px"}}>🏆</span>
            <div>
              <p style={{margin:0,fontSize:"15px",fontWeight:"900",color:C.text}}>Quest Leaderboard</p>
              <p style={{margin:0,fontSize:"11px",color:C.muted}}>Rivendell University · Live Scores</p>
            </div>
          </div>
          <div style={{display:"flex",gap:"8px"}}>
            <button onClick={exportCSV} style={{padding:"8px 14px",borderRadius:"8px",background:C.teal,border:"none",color:"#0A0F1E",fontSize:"12px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit"}}>⬇ Export CSV</button>
            <button onClick={()=>setShowLeaderboard(false)} style={{padding:"8px 14px",borderRadius:"8px",background:C.card,border:`1px solid ${C.border}`,color:C.muted,fontSize:"12px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>← Back</button>
          </div>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"20px"}}>
          {leaderboardData.length === 0 ? (
            <div style={{textAlign:"center",paddingTop:"60px"}}>
              <p style={{fontSize:"48px",marginBottom:"16px"}}>🌀</p>
              <p style={{color:C.muted,fontSize:"16px"}}>No quest data yet. The adventurers are still typing...</p>
            </div>
          ) : leaderboardData.map((row, i) => {
            const medal = i===0?"🥇":i===1?"🥈":i===2?"🥉":"⚔️";
            const pct = Math.round((row.totalCrest / (row.exercisesCompleted * 10)) * 100) || 0;
            return (
              <div key={row.name} style={{background:C.card,borderRadius:"14px",padding:"16px",marginBottom:"12px",border:`1px solid ${i===0?"#5E28E5":C.border}`}}>
                <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"10px"}}>
                  <span style={{fontSize:"24px"}}>{medal}</span>
                  <div style={{flex:1}}>
                    <p style={{margin:0,fontSize:"15px",fontWeight:"800",color:C.text}}>{row.name}</p>
                    <p style={{margin:0,fontSize:"12px",color:C.muted}}>{row.exercisesCompleted}/5 quests · {row.totalCrest} CREST pts · ~{pct}% quality</p>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <p style={{margin:0,fontSize:"22px",fontWeight:"900",color:i===0?C.teal:C.text}}>{row.totalCrest}</p>
                    <p style={{margin:0,fontSize:"10px",color:C.muted,fontWeight:"700"}}>TOTAL</p>
                  </div>
                </div>
                <div style={{display:"flex",gap:"4px"}}>
                  {["C","R","E","S","T"].map(dim => {
                    const best = Math.max(...row.prompts.map(p=>p.crest?.[dim]||0));
                    return (
                      <div key={dim} style={{flex:1,background:C.bg,borderRadius:"6px",padding:"6px 4px",textAlign:"center",border:`1px solid ${C.border}`}}>
                        <p style={{margin:0,fontSize:"13px",fontWeight:"900",color:best>=2?C.teal:best>=1?C.amber:C.muted}}>{best}</p>
                        <p style={{margin:0,fontSize:"10px",color:C.faint,fontWeight:"700"}}>{dim}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // 4. Final Grade screen
  if (showFinalGrade && finalGradeData) {
    const g = finalGradeData;
    return (
      <div style={{height:"100dvh",background:`linear-gradient(135deg, ${C.bg} 0%, #1A1035 100%)`,fontFamily:"'Raleway','Segoe UI',sans-serif",overflowY:"auto",padding:"24px",display:"flex",alignItems:"flex-start",justifyContent:"center"}}>
        <div style={{maxWidth:"520px",width:"100%",paddingTop:"20px",paddingBottom:"40px"}}>
          {/* Header */}
          <div style={{textAlign:"center",marginBottom:"28px"}}>
            <div style={{fontSize:"64px",lineHeight:1,marginBottom:"16px"}}>{g.rankEmoji}</div>
            <h1 style={{color:C.text,fontSize:"26px",fontWeight:"900",margin:"0 0 8px",lineHeight:1.2}}>{adventurerName}</h1>
            <div style={{display:"inline-block",padding:"6px 20px",borderRadius:"20px",background:`linear-gradient(135deg, ${C.purple}, #4312BC)`,marginBottom:"12px"}}>
              <span style={{color:"#fff",fontSize:"13px",fontWeight:"800",letterSpacing:"0.03em"}}>{g.rank}</span>
            </div>
            <p style={{color:C.muted,fontSize:"13px",margin:0,lineHeight:"1.7",maxWidth:"380px",marginLeft:"auto",marginRight:"auto"}}>{g.rankDesc}</p>
          </div>

          {/* Score card */}
          <div style={{background:C.panel,borderRadius:"16px",border:`1px solid ${C.border}`,padding:"20px 24px",marginBottom:"16px"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"16px"}}>
              <div>
                <p style={{margin:0,fontSize:"13px",color:C.muted,fontWeight:"700"}}>Overall Score</p>
                <p style={{margin:0,fontSize:"36px",fontWeight:"900",color:g.pct>=75?C.teal:g.pct>=60?C.amber:C.red,lineHeight:1}}>{g.pct}%</p>
                <p style={{margin:0,fontSize:"12px",color:C.muted}}>{g.earned} / {g.maxTotal} points</p>
              </div>
              {/* Circular score indicator */}
              <div style={{width:"80px",height:"80px",borderRadius:"50%",background:`conic-gradient(${g.pct>=75?C.teal:g.pct>=60?C.amber:C.red} ${g.pct*3.6}deg, #1E2A42 0deg)`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <div style={{width:"62px",height:"62px",borderRadius:"50%",background:C.panel,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <span style={{fontSize:"18px",fontWeight:"900",color:C.text}}>{g.pct}%</span>
                </div>
              </div>
            </div>

            {/* CREST dimension averages */}
            <div>
              <p style={{color:C.muted,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 10px"}}>CREST Breakdown (best per quest)</p>
              <div style={{display:"flex",gap:"8px"}}>
                {["C","R","E","S","T"].map(dim=>{
                  const scores = Object.values(bestScores).map(s=>s[dim]||0);
                  const avg = scores.length ? Math.round((scores.reduce((a,b)=>a+b,0)/scores.length)*10)/10 : 0;
                  const dimNames = {C:"Context",R:"Role",E:"Example",S:"Style",T:"Task"};
                  return (
                    <div key={dim} style={{flex:1,background:C.bg,borderRadius:"10px",padding:"10px 6px",textAlign:"center",border:`1px solid ${avg>=1.5?C.teal:avg>=1?C.amber:C.border}`}}>
                      <p style={{margin:0,fontSize:"18px",fontWeight:"900",color:avg>=1.5?C.teal:avg>=1?C.amber:C.muted}}>{avg}</p>
                      <p style={{margin:0,fontSize:"9px",color:C.muted,fontWeight:"700",marginTop:"2px"}}>{dim}</p>
                      <p style={{margin:0,fontSize:"8px",color:C.faint,marginTop:"1px"}}>{dimNames[dim]}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Per-exercise breakdown */}
          <div style={{background:C.panel,borderRadius:"16px",border:`1px solid ${C.border}`,marginBottom:"16px",overflow:"hidden"}}>
            <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`,background:"#0D1220"}}>
              <p style={{margin:0,fontSize:"12px",fontWeight:"800",color:C.text}}>Quest Breakdown</p>
            </div>
            {g.breakdown.map((ex,i)=>{
              const pct = Math.round((ex.score/10)*100);
              return (
                <div key={i} style={{padding:"12px 20px",borderBottom:i<g.breakdown.length-1?`1px solid ${C.border}`:"none",display:"flex",alignItems:"center",gap:"12px"}}>
                  <span style={{fontSize:"18px",flexShrink:0}}>{ex.emoji}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <p style={{margin:0,fontSize:"12px",fontWeight:"700",color:C.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ex.title}</p>
                    <div style={{height:"4px",background:C.faint,borderRadius:"2px",marginTop:"5px"}}>
                      <div style={{width:`${pct}%`,height:"100%",background:pct>=75?C.teal:pct>=60?C.amber:"#FF6B6B",borderRadius:"2px",transition:"width 0.8s ease"}}/>
                    </div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <p style={{margin:0,fontSize:"14px",fontWeight:"900",color:pct>=75?C.teal:pct>=60?C.amber:"#FF6B6B"}}>{ex.score}/10</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Whitepaper callout */}
          <div style={{background:"rgba(38,191,168,0.08)",borderRadius:"14px",padding:"16px 20px",border:"1px solid rgba(38,191,168,0.2)",marginBottom:"20px"}}>
            <p style={{color:C.teal,fontSize:"11px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 6px"}}>📜 You're in the Whitepaper</p>
            <p style={{color:C.muted,fontSize:"12px",margin:0,lineHeight:"1.7"}}>
              {adventurerEmail ? `We'll send the published whitepaper to ${adventurerEmail}.` : "Your best prompts from today have been saved for the whitepaper."} The field will see what Rivendell University's housing team accomplished with AI today.
            </p>
          </div>

          {/* Actions */}
          <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>

            {/* LinkedIn share — branded */}
            <button
              onClick={()=>window.open('https://kineticsoftwareinc.com/contact-us/','_blank')}
              style={{width:"100%",padding:"16px",borderRadius:"12px",background:`linear-gradient(135deg,${C.purple},#4312BC)`,border:"none",color:"#fff",fontSize:"14px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:"10px"}}>
              <span style={{fontSize:"16px"}}>🏠</span>
              <span>Book a KxWelcome Student Housing Software Demo</span>
            </button>

            {/* Play Again — triggers confirmation popup */}
            <button onClick={()=>setShowPlayAgainConfirm(true)}
              style={{width:"100%",padding:"14px",borderRadius:"12px",background:C.card,border:`1px solid ${C.border}`,color:C.muted,fontSize:"14px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>
              ⚔️ Play Again
            </button>
          </div>

          {/* Play Again confirmation modal */}
          {showPlayAgainConfirm && (
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:"24px"}}>
              <div style={{background:C.panel,borderRadius:"20px",padding:"32px 28px",maxWidth:"380px",width:"100%",border:`1px solid ${C.border}`,boxShadow:"0 24px 80px rgba(0,0,0,0.5)",textAlign:"center"}}>
                <div style={{fontSize:"48px",marginBottom:"16px",lineHeight:1}}>⚔️</div>
                <h2 style={{color:C.text,fontSize:"20px",fontWeight:"900",margin:"0 0 10px"}}>Before you restart…</h2>
                <p style={{color:C.muted,fontSize:"13px",lineHeight:"1.7",margin:"0 0 20px"}}>Have you shared your result on LinkedIn? Your rank of <strong style={{color:C.teal}}>{g.rank}</strong> is worth showing off — and it helps spread the word about AI in student housing.</p>
                {/* LinkedIn share inside modal */}
                <button
                    onClick={()=>window.open('https://kineticsoftwareinc.com/contact-us/','_blank')}
                    style={{width:"100%",padding:"12px",borderRadius:"10px",background:`linear-gradient(135deg,${C.purple},#4312BC)`,border:"none",color:"#fff",fontSize:"12px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:"8px",marginBottom:"10px"}}>
                    <span>🏠</span>
                    <span>Book a KxWelcome Student Housing Software Demo</span>
                  </button>
                <button
                  onClick={()=>{
                    setShowPlayAgainConfirm(false);
                    setShowFinalGrade(false);
                    setCompletedExercises(new Set());
                    setMessages([]);
                    setCurrentExercise(0);
                    setBestScores({});
                    setLastCrest(null);
                    setExerciseHistory({});
                    setShowCelebration(false);
                  }}
                  style={{width:"100%",padding:"13px",borderRadius:"10px",background:"transparent",border:`1px solid ${C.border}`,color:C.muted,fontSize:"13px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>
                  Skip and restart anyway
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 5. Celebration → leads directly to final grade
  if (showCelebration) {
    return (
      <div style={{height:"100dvh",background:`linear-gradient(135deg, ${C.bg} 0%, #2A0A6E 100%)`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Raleway','Segoe UI',sans-serif",padding:"20px"}}>
        <div style={{textAlign:"center",maxWidth:"520px"}}>
          <div style={{fontSize:"72px",marginBottom:"20px",lineHeight:1}}>🧙✨</div>
          <h1 style={{color:C.text,fontSize:"32px",fontWeight:"900",margin:"0 0 16px",lineHeight:1.2}}>
            Quest Complete, {adventurerName.split(" ")[0]}!
          </h1>
          <p style={{color:C.muted,fontSize:"16px",lineHeight:"1.7",margin:"0 0 24px"}}>
            You've completed all 5 housing AI challenges at Rivendell University.
          </p>
          <div style={{padding:"16px 20px",background:"rgba(38,191,168,0.1)",borderRadius:"14px",border:"1px solid rgba(38,191,168,0.2)",marginBottom:"32px"}}>
            <p style={{color:C.teal,fontSize:"14px",margin:0,lineHeight:"1.7"}}>
              📜 Your best prompts have been recorded for the whitepaper.<br/>
              Housing professionals across the field will see your work.
            </p>
          </div>
          <button
            onClick={async ()=>{ 
              const grade = computeFinalGrade();
              setFinalGradeData(grade);
              if (adventurerEmail.trim()) {
                try {
                  await fetch("/.netlify/functions/store", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ action: "save", key: `${SESSION_ID}:email:${adventurerName}`, value: { name:adventurerName, email:adventurerEmail.trim(), pct:grade.pct, rank:grade.rank, ts:Date.now(), type:"email" } })
                  });
                } catch(e) {}
              }
              setShowCelebration(false);
              setShowFinalGrade(true);
            }}
            style={{width:"100%",padding:"18px",borderRadius:"14px",background:`linear-gradient(135deg,${C.teal},#0D7A72)`,border:"none",color:"#fff",fontSize:"17px",fontWeight:"900",cursor:"pointer",fontFamily:"inherit",letterSpacing:"0.02em",boxShadow:"0 8px 32px rgba(38,191,168,0.35)"}}>
            📋 See My Grade →
          </button>
        </div>
      </div>
    );
  }

  // ── PANEL RENDERERS ───────────────────────────────────────────────────────

  // KxWelcome-style light sidebar tokens
  const L = {
    bg:"#EDE7FF",          // richer purple tint
    panel:"#FFFFFF",
    card:"#FAFAFA",
    border:"#EAE6F8",
    borderStrong:"#D4CCF5",
    text:"#1A1035",        // deep purple-black
    muted:"#7B72A8",
    faint:"#EDE9FA",
    purple:"#5E28E5",
    purpleMid:"#7B52F0",
    purpleLight:"#EDE9FA",
    purplePale:"#F5F2FF",
    teal:"#0D9488",
    red:"#DC2626",
    redBg:"#FEF2F2",
    redBorder:"rgba(220,38,38,0.2)",
    amber:"#D97706",
    amberBg:"#FFFBEB",
    urgent:"#B91C1C",
    green:"#059669",
    greenBg:"#ECFDF5",
  };

  const bIcon = (b) => ({'Maple Hall':'🍁','Cedar Tower':'🌲','Oak Commons':'🌿','Birch Hall':'🏛️'}[b]||'🏢');
  const cIcon = (cat) => ({'Plumbing':'💧','HVAC':'❄️','Pest/Drain':'🐛','Fixtures':'🔧','Appliances':'⚡','Security':'🔒','Electrical':'💡'}[cat]||'🔧');

  const renderDataPanel = () => { return (
    <div style={{background:"linear-gradient(160deg, #EDE7FF 0%, #E8DFFF 50%, #DDD5FA 100%)",height:"100%",display:"flex",flexDirection:"column",fontFamily:"'Raleway',-apple-system,sans-serif",boxSizing:"border-box"}}>

      {/* ── Sticky header ── */}
      <div style={{background:L.panel,borderBottom:`1px solid ${L.border}`,padding:"16px 16px 12px",flexShrink:0,position:"sticky",top:0,zIndex:10}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"12px"}}>
          <div style={{width:"32px",height:"32px",borderRadius:"9px",background:`linear-gradient(135deg,${L.purple},${L.purpleMid})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"16px",flexShrink:0,boxShadow:"0 2px 8px rgba(94,40,229,0.3)"}}>🏠</div>
          <div>
            <p style={{margin:0,fontSize:"13px",fontWeight:"800",color:L.text,letterSpacing:"-0.02em",lineHeight:1.2}}>Rivendell University</p>
            <p style={{margin:0,fontSize:"10px",color:L.muted,letterSpacing:"0.01em",lineHeight:1.3}}>KxWelcome Live Housing Data</p>
          </div>
        </div>
        {/* Occupancy hero card */}
        <div style={{borderRadius:"12px",background:"linear-gradient(135deg, #4A0FB5 0%, #6E22D4 45%, #9B2EC4 80%, #B52EA0 100%)",padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",boxShadow:"0 4px 16px rgba(94,40,229,0.25)"}}>
          <div>
            <p style={{margin:"0 0 2px",fontSize:"10px",color:"rgba(255,255,255,0.7)",fontWeight:"600",textTransform:"uppercase",letterSpacing:"0.08em"}}>Total Occupancy</p>
            <p style={{margin:0,fontSize:"28px",fontWeight:"900",color:"#FFFFFF",lineHeight:1,letterSpacing:"-0.03em"}}>{UNIVERSITY_DATA.occupancyRate}%</p>
            <p style={{margin:"3px 0 0",fontSize:"10px",color:"rgba(255,255,255,0.6)"}}>Across all 4 buildings</p>
          </div>
          <div style={{width:"52px",height:"52px",borderRadius:"50%",border:"3px solid rgba(255,255,255,0.3)",display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(255,255,255,0.1)"}}>
            <div style={{width:"36px",height:"36px",borderRadius:"50%",border:"3px solid rgba(255,255,255,0.8)",borderTopColor:"transparent",transform:"rotate(-45deg)"}}/>
          </div>
        </div>
      </div>

      {/* ── Scrollable content ── */}
      <div style={{flex:1,overflowY:"auto",padding:"12px 14px 16px"}}>

        {/* Occupancy by building */}
        <div style={{marginBottom:"10px"}}>
          <button onClick={()=>toggleAcc("occ")} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:L.panel,border:`1px solid ${L.border}`,borderRadius:"14px",cursor:"pointer",padding:"14px 16px",fontFamily:"inherit",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}><div style={{display:"flex",alignItems:"center",gap:"12px"}}><span style={{fontSize:"20px",lineHeight:1}}>🏢</span><span style={{fontSize:"13px",fontWeight:"800",color:"#5E28E5",letterSpacing:"-0.01em"}}>Occupancy</span></div><span style={{fontSize:"18px",fontWeight:"400",color:"#5E28E5",transition:"transform 0.2s",display:"inline-block",transform:accordions.occ?"rotate(180deg)":"rotate(0deg)"}}>⌄</span></button>
          {accordions.occ && (
            <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
              {Object.entries(UNIVERSITY_DATA.occupancy).map(([b,o],i,arr)=>{
                const pct = Math.round((o.occupied/o.total)*100);
                return (
                  <div key={b} style={{padding:"11px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"7px"}}>
                      <span style={{fontSize:"14px",lineHeight:1}}>{bIcon(b)}</span>
                      <span style={{flex:1,fontSize:"12px",fontWeight:"700",color:L.text,letterSpacing:"-0.01em"}}>{b}</span>
                      <span style={{fontSize:"11px",color:L.muted,fontWeight:"500"}}>{o.occupied} / {o.total}</span>
                      <span style={{fontSize:"12px",fontWeight:"800",color:L.purple,minWidth:"36px",textAlign:"right"}}>{pct}%</span>
                    </div>
                    <div style={{height:"5px",background:L.faint,borderRadius:"3px",overflow:"hidden"}}>
                      <div style={{width:`${pct}%`,height:"100%",background:`linear-gradient(90deg,${L.purple},${L.purpleMid})`,borderRadius:"3px",transition:"width 0.6s ease"}}/>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Maintenance requests */}
        <div style={{marginBottom:"10px"}}>
          <button onClick={()=>toggleAcc("maint")} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:L.panel,border:`1px solid ${L.border}`,borderRadius:"14px",cursor:"pointer",padding:"14px 16px",fontFamily:"inherit",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}><div style={{display:"flex",alignItems:"center",gap:"12px"}}><span style={{fontSize:"20px",lineHeight:1}}>🔧</span><span style={{fontSize:"13px",fontWeight:"800",color:"#DC2626",letterSpacing:"-0.01em"}}>Maintenance</span><span style={{fontSize:"11px",fontWeight:"700",color:"#DC2626",background:"#FEF2F2",padding:"2px 9px",borderRadius:"20px",border:"1px solid rgba(220,38,38,0.2)"}}>{UNIVERSITY_DATA.maintenanceTickets.filter(t=>t.priority==="High"||t.priority==="Urgent").length} urgent</span></div><span style={{fontSize:"18px",fontWeight:"400",color:"#DC2626",transition:"transform 0.2s",display:"inline-block",transform:accordions.maint?"rotate(180deg)":"rotate(0deg)"}}>⌄</span></button>
          {accordions.maint && (
            <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
              {UNIVERSITY_DATA.maintenanceTickets.map((t,i,arr)=>(
                <div key={t.id} style={{padding:"10px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none",background:t.priority==="Urgent"?L.redBg:t.priority==="High"?"#FFF8F5":"transparent"}}>
                  <div style={{display:"flex",alignItems:"flex-start",gap:"8px"}}>
                    <span style={{fontSize:"14px",lineHeight:"20px",flexShrink:0}}>{cIcon(t.category)}</span>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"2px"}}>
                        <span style={{fontSize:"11px",fontWeight:"700",color:L.purple}}>{t.id}</span>
                        <span style={{fontSize:"10px",fontWeight:"700",
                          color:t.priority==="Urgent"?L.urgent:t.priority==="High"?L.red:t.priority==="Medium"?L.amber:L.muted,
                          background:t.priority==="Urgent"?L.redBg:t.priority==="High"?"#FEF2F2":t.priority==="Medium"?L.amberBg:"transparent",
                          padding:"1px 6px",borderRadius:"4px"}}>{t.priority}</span>
                      </div>
                      <p style={{fontSize:"11px",color:L.text,margin:"0 0 3px",lineHeight:"1.4",fontWeight:"500",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.issue}</p>
                      <div style={{display:"flex",gap:"8px"}}>
                        <span style={{fontSize:"10px",color:L.muted}}>{t.building}</span>
                        <span style={{fontSize:"10px",color:t.daysOpen>7?L.red:L.muted,fontWeight:t.daysOpen>7?"700":"400"}}>{t.daysOpen}d open</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div style={{padding:"10px 14px",borderTop:`1px solid ${L.border}`,background:L.purplePale}}>
                <span style={{fontSize:"11px",color:L.purple,fontWeight:"700",cursor:"pointer"}}>⁕ View all maintenance →</span>
              </div>
            </div>
          )}
        </div>

        {/* Survey feedback */}
        <div style={{marginBottom:"10px"}}>
          <button onClick={()=>toggleAcc("survey")} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:L.panel,border:`1px solid ${L.border}`,borderRadius:"14px",cursor:"pointer",padding:"14px 16px",fontFamily:"inherit",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}><div style={{display:"flex",alignItems:"center",gap:"12px"}}><span style={{fontSize:"20px",lineHeight:1}}>💬</span><span style={{fontSize:"13px",fontWeight:"800",color:"#0D9488",letterSpacing:"-0.01em"}}>Survey Feedback</span></div><span style={{fontSize:"18px",fontWeight:"400",color:"#0D9488",transition:"transform 0.2s",display:"inline-block",transform:accordions.survey?"rotate(180deg)":"rotate(0deg)"}}>⌄</span></button>
          {accordions.survey && (
            <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
              {UNIVERSITY_DATA.surveyFeedback.map((s,i,arr)=>(
                <div key={s.id} style={{padding:"10px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                  <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"5px"}}>
                    <span style={{fontSize:"10px",fontWeight:"700",color:L.purple,padding:"2px 8px",borderRadius:"20px",background:L.purpleLight,border:`1px solid ${L.borderStrong}`}}>{s.building}</span>
                    <span style={{fontSize:"10px",fontWeight:"600",
                      color:s.sentiment==="positive"||s.sentiment==="mostly positive"?L.green:s.sentiment==="negative"?L.red:L.amber}}>
                      {s.sentiment==="positive"||s.sentiment==="mostly positive"?"↑":s.sentiment==="negative"?"↓":"→"} {s.sentiment}
                    </span>
                  </div>
                  <p style={{fontSize:"11px",color:L.text,margin:0,lineHeight:"1.5",fontStyle:"italic"}}>&ldquo;{s.comment.slice(0,88)}&hellip;&rdquo;</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ── RA STAFF & DUTY POLICY — Quest 3 ── */}
        <div style={{marginBottom:"10px"}}>
          <button onClick={()=>toggleAcc("ra")} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:L.panel,border:`1px solid ${L.border}`,borderRadius:"14px",cursor:"pointer",padding:"14px 16px",fontFamily:"inherit",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}><div style={{display:"flex",alignItems:"center",gap:"12px"}}><span style={{fontSize:"20px",lineHeight:1}}>📅</span><span style={{fontSize:"13px",fontWeight:"800",color:"#7C3AED",letterSpacing:"-0.01em"}}>RA Staff & Duty</span></div><span style={{fontSize:"18px",fontWeight:"400",color:"#7C3AED",transition:"transform 0.2s",display:"inline-block",transform:accordions.ra?"rotate(180deg)":"rotate(0deg)"}}>⌄</span></button>
          {accordions.ra && (
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {/* Duty rules */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>Duty Policy Rules</p>
                </div>
                {UNIVERSITY_DATA.dutyPolicy.rules.map((rule,i,arr)=>(
                  <div key={i} style={{padding:"8px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none",display:"flex",gap:"8px",alignItems:"flex-start"}}>
                    <span style={{color:L.purple,fontSize:"10px",fontWeight:"900",flexShrink:0,marginTop:"1px"}}>→</span>
                    <p style={{fontSize:"11px",color:L.text,margin:0,lineHeight:"1.5"}}>{rule}</p>
                  </div>
                ))}
                <div style={{padding:"8px 14px",background:"#FEF2F2",borderTop:`1px solid ${L.border}`}}>
                  <p style={{margin:0,fontSize:"10px",fontWeight:"700",color:L.red}}>⚠ Blackout Dates</p>
                  {UNIVERSITY_DATA.dutyPolicy.blackoutDates.map((d,i)=>(
                    <p key={i} style={{margin:"2px 0 0",fontSize:"11px",color:L.text}}>{d}</p>
                  ))}
                </div>
              </div>
              {/* RA roster */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>RA Roster — 10 Staff Members</p>
                </div>
                {UNIVERSITY_DATA.raStaff.map((ra,i,arr)=>(
                  <div key={ra.id} style={{padding:"10px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"3px"}}>
                      <span style={{fontSize:"11px",fontWeight:"700",color:L.purple}}>{ra.id}</span>
                      <span style={{fontSize:"12px",fontWeight:"700",color:L.text}}>{ra.name}</span>
                      <span style={{fontSize:"10px",color:L.muted,padding:"1px 6px",borderRadius:"10px",background:L.faint}}>{ra.year}</span>
                      {ra.maxWeekends===0 && <span style={{fontSize:"10px",color:L.amber,fontWeight:"700",padding:"1px 6px",borderRadius:"10px",background:L.amberBg}}>No weekends</span>}
                    </div>
                    <p style={{margin:0,fontSize:"10px",color:L.text}}><span style={{color:L.purple,fontWeight:"700"}}>{ra.building}</span> · {ra.constraints}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ── EMAIL TEMPLATES & FAQ — Quest 4 ── */}
        <div style={{marginBottom:"10px"}}>
          <button onClick={()=>toggleAcc("templates")} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:L.panel,border:`1px solid ${L.border}`,borderRadius:"14px",cursor:"pointer",padding:"14px 16px",fontFamily:"inherit",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}><div style={{display:"flex",alignItems:"center",gap:"12px"}}><span style={{fontSize:"20px",lineHeight:1}}>📧</span><span style={{fontSize:"13px",fontWeight:"800",color:"#B45309",letterSpacing:"-0.01em"}}>Templates & FAQ</span></div><span style={{fontSize:"18px",fontWeight:"400",color:"#B45309",transition:"transform 0.2s",display:"inline-block",transform:accordions.templates?"rotate(180deg)":"rotate(0deg)"}}>⌄</span></button>
          {accordions.templates && (
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {/* Email templates */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>6 Canned Email Templates</p>
                </div>
                {UNIVERSITY_DATA.emailTemplates.map((t,i,arr)=>(
                  <div key={t.id} style={{padding:"10px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"3px"}}>
                      <span style={{fontSize:"10px",fontWeight:"700",color:L.purple,padding:"1px 6px",borderRadius:"4px",background:L.purpleLight}}>{t.id}</span>
                      <span style={{fontSize:"11px",fontWeight:"700",color:L.text}}>{t.category}</span>
                    </div>
                    <p style={{margin:0,fontSize:"11px",color:L.muted,fontStyle:"italic"}}>"{t.subject}"</p>
                    <p style={{margin:"3px 0 0",fontSize:"10px",color:L.text,lineHeight:"1.4"}}>{t.body.slice(0,100)}…</p>
                  </div>
                ))}
              </div>
              {/* FAQ */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>8 FAQ Answers</p>
                </div>
                {UNIVERSITY_DATA.faq.map((f,i,arr)=>(
                  <div key={i} style={{padding:"9px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                    <p style={{margin:"0 0 2px",fontSize:"11px",fontWeight:"700",color:L.text}}>Q: {f.q}</p>
                    <p style={{margin:0,fontSize:"10px",color:L.muted,lineHeight:"1.4"}}>A: {f.a}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ── TREND DATA — Quest 5 ── */}
        <div style={{marginBottom:"10px"}}>
          <button onClick={()=>toggleAcc("trends")} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:L.panel,border:`1px solid ${L.border}`,borderRadius:"14px",cursor:"pointer",padding:"14px 16px",fontFamily:"inherit",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}><div style={{display:"flex",alignItems:"center",gap:"12px"}}><span style={{fontSize:"20px",lineHeight:1}}>🔮</span><span style={{fontSize:"13px",fontWeight:"800",color:"#0F766E",letterSpacing:"-0.01em"}}>Trends & Analytics</span></div><span style={{fontSize:"18px",fontWeight:"400",color:"#0F766E",transition:"transform 0.2s",display:"inline-block",transform:accordions.trends?"rotate(180deg)":"rotate(0deg)"}}>⌄</span></button>
          {accordions.trends && (
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {/* Occupancy history */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>Occupancy % by Year</p>
                </div>
                <div style={{padding:"10px 14px"}}>
                  <div style={{display:"grid",gridTemplateColumns:"80px 1fr 1fr 1fr 1fr",gap:"4px 8px",fontSize:"10px"}}>
                    <span style={{color:L.muted,fontWeight:"700"}}>Year</span>
                    {["Maple Hall","Cedar Tower","Oak Commons","Birch Hall"].map(b=>(
                      <span key={b} style={{color:L.purple,fontWeight:"700"}}>{b.split(" ")[0]}</span>
                    ))}
                    {UNIVERSITY_DATA.trendData.occupancyHistory.map(y=>(
                      [<span key={y.year+"yr"} style={{color:L.text,fontWeight:"600"}}>{y.year}</span>,
                       ...["Maple Hall","Cedar Tower","Oak Commons","Birch Hall"].map(b=>(
                        <span key={y.year+b} style={{color:L.text}}>{y[b]}%</span>
                      ))]
                    ))}
                  </div>
                </div>
              </div>
              {/* Academic distribution */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>Academic & Demographic Data</p>
                </div>
                {UNIVERSITY_DATA.trendData.academicDistribution.map((b,i,arr)=>(
                  <div key={b.building} style={{padding:"10px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"4px"}}>
                      <span style={{fontSize:"12px",fontWeight:"700",color:L.text}}>{b.building}</span>
                      <div style={{display:"flex",gap:"8px"}}>
                        <span style={{fontSize:"10px",color:L.purple,fontWeight:"700"}}>GPA {b.avgGPA}</span>
                        <span style={{fontSize:"10px",color:L.green,fontWeight:"700"}}>{b.retentionRate} retention</span>
                      </div>
                    </div>
                    <p style={{margin:"0 0 3px",fontSize:"10px",color:L.muted}}>{b.topMajors.join(" · ")}</p>
                    <p style={{margin:0,fontSize:"10px",color:L.text,lineHeight:"1.4",fontStyle:"italic"}}>{b.notes}</p>
                  </div>
                ))}
              </div>
              {/* Maintenance history */}
              <div style={{background:L.panel,borderRadius:"12px",border:`1px solid ${L.border}`,overflow:"hidden",boxShadow:"0 1px 4px rgba(94,40,229,0.06)"}}>
                <div style={{padding:"10px 14px",borderBottom:`1px solid ${L.border}`,background:L.purplePale}}>
                  <p style={{margin:0,fontSize:"11px",fontWeight:"800",color:L.purple}}>Maintenance Ticket History (3-Year)</p>
                </div>
                {UNIVERSITY_DATA.trendData.maintenanceHistory.map((b,i,arr)=>(
                  <div key={b.building} style={{padding:"10px 14px",borderBottom:i<arr.length-1?`1px solid ${L.border}`:"none"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"3px"}}>
                      <span style={{fontSize:"12px",fontWeight:"700",color:L.text}}>{b.building}</span>
                      <span style={{fontSize:"10px",fontWeight:"700",color:b.tickets2526>b.tickets2425?L.red:L.green}}>
                        {b.tickets2324} → {b.tickets2425} → {b.tickets2526} tickets
                      </span>
                    </div>
                    <p style={{margin:"0 0 2px",fontSize:"10px",color:L.purple,fontWeight:"700"}}>Primary: {b.primaryCategory}</p>
                    <p style={{margin:0,fontSize:"10px",color:L.text,lineHeight:"1.4",fontStyle:"italic"}}>{b.note}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
  };

    const renderWorkspacePanel = () => { return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",minHeight:0}}>

      {/* ── CHAT AREA — scrollable ── */}
      <div style={{flex:1,overflowY:"auto",display:"flex",flexDirection:"column",minHeight:0,WebkitOverflowScrolling:"touch"}}>

        {/* Empty state — exercise brief, no auto-prompt bubbles */}
        {messages.length===0 && (
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"32px 10%",textAlign:"center"}}>
            <div style={{fontSize:"44px",marginBottom:"14px",lineHeight:1}}>🧙</div>
            <h2 style={{color:C.text,fontSize:"20px",fontWeight:"900",margin:"0 0 20px"}}>{exercise.emoji} {exercise.title}</h2>
            {/* Full scenario + task card */}
            <div style={{borderRadius:"16px",maxWidth:"580px",width:"100%",overflow:"hidden",border:`1px solid ${C.border}`,boxShadow:"0 2px 20px rgba(0,0,0,0.25)"}}>
              <div style={{background:C.card,padding:"20px 24px 16px",textAlign:"center",borderBottom:`1px solid ${C.border}`}}>
                <div style={{display:"inline-flex",alignItems:"center",gap:"6px",padding:"3px 10px",borderRadius:"20px",background:"rgba(94,40,229,0.15)",border:"1px solid rgba(94,40,229,0.3)",marginBottom:"10px"}}>
                  <span style={{fontSize:"10px"}}>✦</span>
                  <span style={{fontSize:"10px",fontWeight:"700",color:"#9B7AFF",textTransform:"uppercase",letterSpacing:"0.08em"}}>Scenario</span>
                </div>
                <p style={{color:C.text,fontSize:"12px",margin:0,lineHeight:"1.6"}}>{exercise.context}</p>
              </div>
              <div style={{background:"#0D1220",padding:"18px 24px",textAlign:"center"}}>
                <div style={{display:"inline-flex",alignItems:"center",gap:"6px",padding:"3px 10px",borderRadius:"20px",background:"rgba(38,191,168,0.12)",border:"1px solid rgba(38,191,168,0.25)",marginBottom:"10px"}}>
                  <span style={{fontSize:"10px"}}>🎯</span>
                  <span style={{fontSize:"10px",fontWeight:"700",color:C.teal,textTransform:"uppercase",letterSpacing:"0.08em"}}>Your Task</span>
                </div>
                <p style={{color:"#C8D0FF",fontSize:"12px",margin:0,lineHeight:"1.6"}}>{exercise.instruction}</p>
              </div>
            </div>
            <p style={{color:C.muted,fontSize:"12px",margin:"16px 0 0"}}>Type your prompt in the box below ↓</p>
          </div>
        )}

        {/* Messages */}
        {messages.length>0 && (
          <div style={{padding:"20px 10%",display:"flex",flexDirection:"column",gap:"16px"}}>
            {messages.map(msg=>(
              <div key={msg.id} style={{display:"flex",flexDirection:msg.role==="user"?"row-reverse":"row",alignItems:"flex-start",gap:"10px"}}>
                <div style={{width:"30px",height:"30px",borderRadius:"50%",flexShrink:0,background:msg.role==="user"?C.purple:"linear-gradient(135deg,#26BFA8,#5E28E5)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"14px"}}>
                  {msg.role==="user"?"⚔️":"🧙"}
                </div>
                <div style={{maxWidth:"78%",padding:"12px 16px",borderRadius:msg.role==="user"?"18px 4px 18px 18px":"4px 18px 18px 18px",background:msg.role==="user"?C.purple:C.card,border:msg.role==="assistant"?`1px solid ${C.border}`:"none",color:C.text,fontSize:"14px",lineHeight:"1.8",whiteSpace:"pre-wrap",wordBreak:"break-word"}}>
                  {msg.content}
                </div>
              </div>
            ))}
            {streamingText && (
              <div style={{display:"flex",alignItems:"flex-start",gap:"10px"}}>
                <div style={{width:"30px",height:"30px",borderRadius:"50%",background:"linear-gradient(135deg,#26BFA8,#5E28E5)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"14px",flexShrink:0}}>🧙</div>
                <div style={{maxWidth:"78%",padding:"12px 16px",borderRadius:"4px 18px 18px 18px",background:C.card,border:`1px solid ${C.border}`,color:C.text,fontSize:"14px",lineHeight:"1.8",whiteSpace:"pre-wrap",wordBreak:"break-word"}}>
                  {streamingText}<span style={{display:"inline-block",width:"2px",height:"14px",background:C.teal,marginLeft:"2px",verticalAlign:"text-bottom",animation:"blink 1s infinite"}}/>
                </div>
              </div>
            )}
            {isLoading && !streamingText && (
              <div style={{display:"flex",alignItems:"flex-start",gap:"10px",paddingLeft:"8px",paddingBottom:"8px"}}>
                <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:"14px 14px 14px 0",padding:"12px 16px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
                    <span style={{fontSize:"16px",animation:"blink 1.2s infinite"}}>🧙</span>
                    <div>
                      <p style={{color:C.text,margin:0,fontSize:"13px",fontWeight:"700",lineHeight:1.3}}>Consulting the housing grimoire…</p>
                      <p style={{color:C.muted,margin:"3px 0 0",fontSize:"11px"}}>Complex quests can take 15–30 seconds. Hang tight.</p>
                    </div>
                    <div style={{display:"flex",gap:"4px"}}>
                      {[0,1,2].map(i=><div key={i} style={{width:"6px",height:"6px",borderRadius:"50%",background:C.purple,animation:`bounce 1.2s ease-in-out ${i*0.2}s infinite`}}/>)}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div ref={messagesEndRef}/>
          </div>
        )}
        {messages.length===0 && <div ref={messagesEndRef}/>}
      </div>

      {/* ── PROMPT INPUT — centered, Claude-style ── */}
      <div style={{padding:"12px 10%",background:C.bg,flexShrink:0}}>
        <div style={{background:C.card,borderRadius:"16px",border:`1px solid ${C.border}`,padding:"12px 16px",boxShadow:"0 0 0 1px rgba(94,40,229,0.1), 0 4px 24px rgba(0,0,0,0.3)"}}>
          <textarea ref={textareaRef} value={input}
            onChange={e=>{
              setInput(e.target.value);
              const el = e.target;
              el.style.height = "auto";
              if (e.target.value.trim() === "") {
                el.style.height = "auto";
                el.rows = 2;
              } else {
                el.rows = 2;
                el.style.height = Math.min(el.scrollHeight, 200) + "px";
              }
            }}
            onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendMessage();}}}
            placeholder="Cast your prompt spell…"
            rows={2}
            style={{width:"100%",background:"none",border:"none",color:"#FFFFFF",fontSize:"16px",fontFamily:"inherit",resize:"none",outline:"none",lineHeight:"1.6",overflowY:"auto",boxSizing:"border-box"}}/>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:"8px",paddingTop:"8px",borderTop:`1px solid ${C.border}`}}>
            <span style={{color:C.muted,fontSize:"11px"}}>↩ Enter to send · Shift+Enter for new line</span>
            <button onClick={()=>sendMessage()} disabled={isLoading||!input.trim()}
              style={{padding:"8px 20px",borderRadius:"10px",background:isLoading||!input.trim()?"#1E2A42":`linear-gradient(135deg, ${C.purple}, #4312BC)`,border:"none",cursor:isLoading||!input.trim()?"not-allowed":"pointer",color:"#fff",fontSize:"13px",fontWeight:"700",fontFamily:"inherit",transition:"all 0.2s"}}>
              {isLoading?"Casting…":"Send ↑"}
            </button>
          </div>
        </div>
      </div>

      {/* ── BOTTOM INTEL BAR — learning context OR score result ── */}
      <div className="desktop-workspace" style={{borderTop:`1px solid ${C.border}`,flexShrink:0,background:C.panel}}>
        {lastCrest ? (() => {
          // ── SCORE STATE: full-width magical result bar ──
          const total = ["C","R","E","S","T"].reduce((s,d)=>s+(lastCrest[d]||0),0);
          const pct = Math.round((total/10)*100);
          const isGreat = pct >= 80;
          const isMid   = pct >= 50 && pct < 80;
          const scoreColor = isGreat ? C.teal : isMid ? C.amber : "#FF6B6B";
          const magicPrefix = isGreat
            ? ["✨ The ancient scrolls speak highly of your craft!","🧙 A masterful incantation — the housing spirits are impressed!","⚡ Your prompt radiates rare wisdom, Adventurer!"][total%3]
            : isMid
            ? ["📜 A decent spell, though the grimoire sensed room for more power.","🌀 The magic partially took hold — your intent was clear, your form needs sharpening.","🔮 Solid conjuring. The oracle suggests a stronger cast next time."][total%3]
            : ["🌱 The spell fizzled — the housing spirits await a clearer command.","💨 A whisper when the quest needed a battle cry. Try again, Adventurer.","🕯️ The scroll remains mostly blank. Speak more specifically to the magic."][total%3];

          return (
            <div style={{display:"flex",alignItems:"center",gap:"0",padding:"0"}}>
              {/* Percentage badge */}
              <div style={{padding:"10px 18px",borderRight:`1px solid ${C.border}`,flexShrink:0,textAlign:"center",minWidth:"70px"}}>
                <p style={{margin:0,fontSize:"20px",fontWeight:"900",color:scoreColor,lineHeight:1}}>{pct}%</p>
                <p style={{margin:0,fontSize:"9px",color:C.muted,fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.06em",marginTop:"2px"}}>This prompt</p>
              </div>
              {/* CREST mini bars */}
              <div style={{padding:"8px 14px",borderRight:`1px solid ${C.border}`,display:"flex",gap:"6px",alignItems:"center",flexShrink:0}}>
                {["C","R","E","S","T"].map(dim=>{
                  const val = lastCrest[dim]||0;
                  const dimColor = val>=2?C.teal:val>=1?C.amber:"#3D4A6A";
                  return (
                    <div key={dim} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"2px"}}>
                      <div style={{width:"22px",height:"22px",borderRadius:"6px",background:val>=2?"rgba(38,191,168,0.15)":val>=1?"rgba(255,179,71,0.15)":"rgba(61,74,106,0.3)",border:`1px solid ${dimColor}`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <span style={{fontSize:"12px",fontWeight:"900",color:dimColor}}>{val}</span>
                      </div>
                      <span style={{fontSize:"8px",fontWeight:"700",color:C.muted,letterSpacing:"0.05em"}}>{dim}</span>
                    </div>
                  );
                })}
              </div>
              {/* Magical feedback */}
              <div style={{flex:1,padding:"10px 16px"}}>
                <p style={{margin:"0 0 2px",fontSize:"10px",fontWeight:"700",color:scoreColor}}>{magicPrefix}</p>
                <p style={{margin:0,fontSize:"11px",color:C.muted,lineHeight:"1.5"}}>{lastCrest.feedback}</p>
              </div>
              {/* Reset */}
              <div style={{padding:"10px 16px",borderLeft:`1px solid ${C.border}`,flexShrink:0}}>
                <button onClick={clearConversation} style={{padding:"6px 14px",borderRadius:"8px",background:C.card,border:`1px solid ${C.border}`,color:C.muted,fontSize:"11px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>↺ Reset</button>
              </div>
            </div>
          );
        })() : (
          // ── DEFAULT STATE: You're Learning + CREST Focus + Tip ──
          <div style={{display:"flex",gap:"0"}}>
            <div style={{flex:"1.2",padding:"9px 16px",borderRight:`1px solid ${C.border}`}}>
              <p style={{color:C.teal,fontSize:"9px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 4px"}}>📚 You're Learning</p>
              <div style={{display:"flex",flexWrap:"wrap",gap:"4px"}}>
                {exercise.teachingFocus.map(t=>(
                  <span key={t} style={{padding:"2px 8px",borderRadius:"10px",background:"#1A1035",border:"1px solid #2A1A5E",color:"#9B7AFF",fontSize:"10px",fontWeight:"700"}}>{t}</span>
                ))}
              </div>
            </div>
            <div style={{flex:"1.5 1 180px",padding:"9px 16px",borderRight:`1px solid ${C.border}`}}>
              <p style={{color:C.teal,fontSize:"9px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 4px"}}>⚡ CREST Focus</p>
              <p style={{color:C.text,fontSize:"11px",margin:0,lineHeight:"1.5"}}>{exercise.crestFocus}</p>
            </div>
            <div style={{flex:"0.8 1 120px",padding:"9px 16px"}}>
              <p style={{color:C.teal,fontSize:"9px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 4px"}}>💡 Tip</p>
              <p style={{color:C.muted,fontSize:"11px",margin:0,lineHeight:"1.5"}}>{exercise.promptingTip}</p>
            </div>
          </div>
        )}
      </div>

    </div>
  );
  };

  // ── MAIN LAYOUT ───────────────────────────────────────────────────────────
  return (
    <div style={{height:"100dvh",maxWidth:"100vw",width:"100%",background:C.bg,fontFamily:"'Raleway','Segoe UI',sans-serif",display:"flex",flexDirection:"column",color:C.text,overflow:"hidden",position:"relative"}}>

      {/* ── DESKTOP: side-by-side row ── */}
      <div className="desktop-row" style={{flex:1,display:"flex",flexDirection:"row",minHeight:0,overflow:"hidden"}}>
        <div style={{width:"300px",flexShrink:0,borderRight:"1px solid #D4CCF5",overflowY:"auto",height:"100%"}}>
          {renderDataPanel()}
        </div>

        {/* ── Right side: top bar + workspace stacked ── */}
        <div style={{flex:1,minWidth:0,display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>

        {/* TOP BAR — sits only above the workspace */}
        <div style={{padding:"0 14px",paddingTop:"env(safe-area-inset-top,0px)",height:"calc(52px + env(safe-area-inset-top,0px))",background:C.panel,borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"flex-end",paddingBottom:"8px",justifyContent:"space-between",flexShrink:0,gap:"10px"}}>
          {/* Logo */}
          <div style={{display:"flex",alignItems:"center",gap:"8px",flexShrink:0}}>
            <span style={{fontSize:"22px",lineHeight:1}}>🧙</span>
            <div>
              <p style={{margin:0,fontWeight:"900",fontSize:"14px",color:C.text,lineHeight:1.1}}>KxWizard</p>
              <p style={{margin:0,fontSize:"10px",color:C.muted,lineHeight:1.1}}>Rivendell U.</p>
            </div>
          </div>

          {/* Exercise pills */}
          <div style={{display:"flex",gap:"5px",overflowX:"auto",flex:1,justifyContent:"center",scrollbarWidth:"none"}} className="no-scroll">
            {EXERCISES.map((ex,i)=>(
              <button key={ex.id} onClick={()=>{setCurrentExercise(i);setMessages([]);setLastCrest(null);}} style={pill(currentExercise===i)}>
                {completedExercises.has(i)?"✅":ex.emoji} <span className="pill-label">{ex.id}</span>
              </button>
            ))}
          </div>

          {/* Right controls */}
          <div style={{display:"flex",alignItems:"center",gap:"8px",flexShrink:0}}>
            <div style={{width:"60px",height:"5px",background:C.faint,borderRadius:"3px"}}>
              <div style={{width:`${progressPct}%`,height:"100%",background:`linear-gradient(90deg,${C.purple},${C.teal})`,borderRadius:"3px",transition:"width 0.5s ease"}}/>
            </div>
            {completedExercises.size === EXERCISES.length && (
              <button onClick={handleTurnIn}
                style={{padding:"6px 14px",borderRadius:"8px",background:`linear-gradient(135deg,${C.teal},#0D7A72)`,border:"none",color:"#fff",fontSize:"12px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit",animation:"pulse 2s infinite"}}>
                📋 Turn In
              </button>
            )}
          </div>
        </div>

        {/* Workspace fills remaining height on desktop / mobile layout below */}
        <div style={{flex:1,minHeight:0,overflow:"hidden"}} className="desktop-workspace">
          {renderWorkspacePanel()}
        </div>

        {/* closes right-side column */}
        </div>

      {/* closes desktop-row */}
      </div>

      {/* ── MOBILE layout — sibling to desktop-row, shown only on small screens ── */}
      <div className="mobile-layout" style={{flex:1,display:"flex",flexDirection:"column",minHeight:0,overflow:"hidden",height:"100%",position:"relative"}}>

        {/* Mobile top bar — KxWizard logo + progress */}
        <div style={{padding:"10px 14px",paddingTop:"calc(env(safe-area-inset-top,0px) + 10px)",background:C.panel,borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0,gap:"10px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
            <span style={{fontSize:"20px",lineHeight:1}}>🧙</span>
            <p style={{margin:0,fontWeight:"900",fontSize:"14px",color:C.text,lineHeight:1}}>KxWizard</p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
            <div style={{width:"50px",height:"4px",background:C.faint,borderRadius:"2px"}}>
              <div style={{width:`${progressPct}%`,height:"100%",background:`linear-gradient(90deg,${C.purple},${C.teal})`,borderRadius:"2px",transition:"width 0.5s"}}/>
            </div>
            {completedExercises.size === EXERCISES.length && (
              <button onClick={handleTurnIn}
                style={{padding:"5px 10px",borderRadius:"7px",background:`linear-gradient(135deg,${C.teal},#0D7A72)`,border:"none",color:"#fff",fontSize:"11px",fontWeight:"800",cursor:"pointer",fontFamily:"inherit"}}>
                📋 Turn In
              </button>
            )}
          </div>
        </div>

        {/* Mobile exercise pill row */}
        <div style={{padding:"8px 12px",background:C.panel,borderBottom:`1px solid ${C.border}`,display:"flex",gap:"6px",overflowX:"auto",flexShrink:0}} className="no-scroll">
          {EXERCISES.map((ex,i)=>(
            <button key={ex.id}
              onClick={()=>{setCurrentExercise(i);setMessages([]);setLastCrest(null);setMobileTab("workspace");}}
              style={{
                padding:"6px 12px",borderRadius:"8px",border:"none",cursor:"pointer",
                fontFamily:"inherit",fontSize:"12px",fontWeight:"800",whiteSpace:"nowrap",flexShrink:0,
                background:currentExercise===i?C.purple:C.card,
                color:currentExercise===i?"#fff":C.muted,
                border:currentExercise===i?`1px solid ${C.purple}`:`1px solid ${C.border}`,
                transition:"all 0.15s"
              }}>
              {completedExercises.has(i)?"✅":ex.emoji} {ex.id}. {ex.title.split(" ").slice(0,2).join(" ")}
            </button>
          ))}
        </div>

        <div style={{flex:1,minHeight:0,overflow:"hidden",paddingBottom:"0"}}>
          {mobileTab==="data"      && <div style={{height:"100%",background:C.panel,overflowY:"auto"}}>{renderDataPanel()}</div>}
          {mobileTab==="workspace" && renderWorkspacePanel()}
          {mobileTab==="guide"     && (
            <div style={{height:"100%",background:C.bg,overflowY:"auto",padding:"16px",boxSizing:"border-box"}}>
              <p style={{color:C.muted,fontSize:"10px",fontWeight:"700",letterSpacing:"0.1em",textTransform:"uppercase",margin:"0 0 14px"}}>
                ⚡ Quest Intel — {exercise.emoji} {exercise.title}
              </p>

              {/* You're Learning */}
              <div style={{background:C.card,borderRadius:"12px",padding:"14px 16px",border:`1px solid ${C.border}`,marginBottom:"10px"}}>
                <p style={{color:C.teal,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 8px"}}>📚 You're Learning</p>
                <div style={{display:"flex",flexWrap:"wrap",gap:"6px"}}>
                  {exercise.teachingFocus.map(t=>(
                    <span key={t} style={{padding:"5px 12px",borderRadius:"20px",background:"#1A1035",border:"1px solid #2A1A5E",color:"#9B7AFF",fontSize:"13px",fontWeight:"700"}}>{t}</span>
                  ))}
                </div>
              </div>

              {/* CREST Focus */}
              <div style={{background:C.card,borderRadius:"12px",padding:"14px 16px",border:`1px solid ${C.border}`,marginBottom:"10px"}}>
                <p style={{color:C.teal,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 8px"}}>⚡ CREST Focus</p>
                <p style={{color:C.text,fontSize:"13px",margin:0,lineHeight:"1.7"}}>{exercise.crestFocus}</p>
              </div>

              {/* Prompting Tip */}
              <div style={{background:C.card,borderRadius:"12px",padding:"14px 16px",border:`1px solid ${C.border}`,marginBottom:"10px"}}>
                <p style={{color:C.teal,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 8px"}}>💡 Prompting Tip</p>
                <p style={{color:C.muted,fontSize:"13px",margin:0,lineHeight:"1.7"}}>{exercise.promptingTip}</p>
              </div>

              {/* CREST score — magical themed result card */}
              {lastCrest && (()=>{
                const total = ["C","R","E","S","T"].reduce((s,d)=>s+(lastCrest[d]||0),0);
                const pct = Math.round((total/10)*100);
                const isGreat = pct >= 80;
                const isMid   = pct >= 50 && pct < 80;
                const scoreColor = isGreat ? C.teal : isMid ? C.amber : "#FF6B6B";
                const scoreBg    = isGreat ? "rgba(38,191,168,0.08)" : isMid ? "rgba(255,179,71,0.08)" : "rgba(255,107,107,0.08)";
                const scoreBorder= isGreat ? "1px solid rgba(38,191,168,0.25)" : isMid ? "1px solid rgba(255,179,71,0.25)" : "1px solid rgba(255,107,107,0.25)";
                const magicPrefix = isGreat
                  ? ["✨ The ancient scrolls speak highly of your craft!","🧙 A masterful incantation — the housing spirits are impressed!","⚡ Your prompt radiates rare wisdom, Adventurer!"][total%3]
                  : isMid
                  ? ["📜 A decent spell, though the grimoire sensed room for more power.","🌀 The magic partially took hold — your intent was clear, your form needs sharpening.","🔮 Solid conjuring. The oracle suggests a stronger cast next time."][total%3]
                  : ["🌱 The spell fizzled — the housing spirits await a clearer command.","💨 A whisper when the quest needed a battle cry. Try again, Adventurer.","🕯️ The scroll remains mostly blank. Speak more specifically to the magic."][total%3];
                return (
                  <div style={{background:scoreBg,borderRadius:"14px",padding:"16px",border:scoreBorder,marginBottom:"10px"}}>
                    {/* Score header */}
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"12px"}}>
                      <div>
                        <p style={{margin:0,fontSize:"28px",fontWeight:"900",color:scoreColor,lineHeight:1}}>{pct}%</p>
                        <p style={{margin:0,fontSize:"10px",color:C.muted,fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.06em",marginTop:"2px"}}>This prompt</p>
                      </div>
                      <div style={{display:"flex",gap:"6px"}}>
                        {["C","R","E","S","T"].map(dim=>{
                          const val = lastCrest[dim]||0;
                          const dc = val>=2?C.teal:val>=1?C.amber:"#3D4A6A";
                          return (
                            <div key={dim} style={{width:"28px",height:"28px",borderRadius:"7px",background:`rgba(${val>=2?"38,191,168":val>=1?"255,179,71":"61,74,106"},0.15)`,border:`1px solid ${dc}`,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"1px"}}>
                              <span style={{fontSize:"11px",fontWeight:"900",color:dc,lineHeight:1}}>{val}</span>
                              <span style={{fontSize:"7px",fontWeight:"700",color:C.muted,lineHeight:1}}>{dim}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {/* Magical message */}
                    <p style={{margin:"0 0 6px",fontSize:"12px",fontWeight:"700",color:scoreColor}}>{magicPrefix}</p>
                    {lastCrest.feedback && <p style={{margin:0,fontSize:"12px",color:C.muted,lineHeight:"1.6",fontStyle:"italic"}}>{lastCrest.feedback}</p>}
                    {/* Reset */}
                    <button onClick={()=>{clearConversation();setMobileTab("workspace");}}
                      style={{marginTop:"12px",width:"100%",padding:"10px",borderRadius:"10px",background:C.card,border:`1px solid ${C.border}`,color:C.muted,fontSize:"13px",fontWeight:"700",cursor:"pointer",fontFamily:"inherit"}}>
                      ↺ Reset this quest
                    </button>
                  </div>
                );
              })()}

              {/* Whitepaper callout */}
              <div style={{background:"rgba(38,191,168,0.06)",borderRadius:"12px",padding:"14px 16px",border:"1px solid rgba(38,191,168,0.2)"}}>
                <p style={{color:C.teal,fontSize:"10px",fontWeight:"700",textTransform:"uppercase",letterSpacing:"0.08em",margin:"0 0 6px"}}>📜 Whitepaper Quest</p>
                <p style={{color:C.muted,fontSize:"13px",margin:0,lineHeight:"1.7"}}>Your best prompt from Quest 5 will be featured in the published whitepaper, with your institution credited.</p>
              </div>
            </div>
          )}
        </div>
        <div style={{display:"flex",background:C.panel,borderTop:`1px solid ${C.border}`,paddingBottom:"max(env(safe-area-inset-bottom,0px), 8px)",paddingTop:"8px",flexShrink:0,zIndex:100,height:"68px",boxSizing:"border-box"}}>
          {[{id:"data",icon:"📁",label:"Data"},{id:"workspace",icon:"💬",label:"Quest"},{id:"guide",icon:"⚡",label:"CREST"}].map(tab=>(
            <button key={tab.id} onClick={()=>setMobileTab(tab.id)}
              style={{flex:1,padding:"12px 4px 10px",background:"none",border:"none",display:"flex",flexDirection:"column",alignItems:"center",gap:"3px",
                color:mobileTab===tab.id?C.purple:C.muted,cursor:"pointer",fontFamily:"inherit",
                borderTop:mobileTab===tab.id?`2px solid ${C.purple}`:"2px solid transparent",transition:"color 0.15s"}}>
              <span style={{fontSize:"24px",lineHeight:1}}>{tab.icon}</span>
              <span style={{fontSize:"11px",fontWeight:"700",letterSpacing:"0.05em"}}>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;600;700;800;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        ::-webkit-scrollbar{width:3px;}
        ::-webkit-scrollbar-track{background:#0A0F1E;}
        ::-webkit-scrollbar-thumb{background:#2A3550;border-radius:2px;}
        textarea{resize:none!important;-webkit-appearance:none;}
        *{-webkit-tap-highlight-color:transparent;touch-action:manipulation;}
        .mobile-layout{touch-action:pan-y;overscroll-behavior-y:contain;}textarea::placeholder{color:rgba(255,255,255,0.4)!important;opacity:1!important;}
        html,body{overflow:hidden;height:100%;overscroll-behavior:none;position:fixed;width:100%;max-width:100vw;}
        #root{width:100%;height:100%;overflow:hidden;}
        @keyframes blink{0%,100%{opacity:1;}50%{opacity:0;}}
        @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.7;}}@keyframes bounce{0%,80%,100%{transform:translateY(0);opacity:0.4;}40%{transform:translateY(-7px);opacity:1;}}
        .no-scroll::-webkit-scrollbar{display:none;}
        .desktop-layout{display:none!important;}.desktop-workspace{display:none!important;}.desktop-row{display:none!important;}
        .mobile-layout{display:flex!important;}
        @media(min-width:768px){
          .desktop-layout{display:flex!important;}.desktop-workspace{display:block!important;}.desktop-row{display:flex!important;}
          .mobile-layout{display:none!important;}
        }
      `}</style>
    </div>
  );
}
